import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../../config.json";
import PageSizeOptions from "../PageSizeOptions";
import AddCandidate from "./AddCandidate";
import Moment from "react-moment";
import ActiveDeactiveHistory from "../SystemAdministration/ManagePartner/ActiveDeactiveHistory";
import { paginate, calculateIndex } from "../../utlis/paginate";
import ReminderAlertMessage from "../ReminderAlertMessage";
import ViewCandidate from "./ViewCandidate";
import Pagination from "../../comman/pagination";
import SearchableSelect from "../../comman/SearchableSelect";
import AddEditDuration from "./AddEditDuration";
import {
  loadCandidates, getAllCandidates,
  getFilterAllCandidates,
  SendReminder, getReminderStatus,
  loadAllCandidatesByFilter,
  candidateBprmFormReceived,
  getCandidateBprmForm,
  loadCandidateBprmForm,
  selectedCandidateObjReceiveClear,
  getCandidateApps,
  filterAllCandidatesStatus,
  getFilterCandidatesStatus,
  receivedCandidateById,
  getCandidateNameList,
  loadCandidateNameList,
  candidateAppsReceived
} from "../../app/store/candidate";
import {
  getCurrentUser,
  getUserProfilePicsById,
  loadUserProfilePicById,
} from "../../app/store/auth";
import { getFieldData, getFormatedNumber } from "../../services/appService";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getAlert } from "../../services/appAlerts";
import AddEditRates from "./AddEditRates";
import Document from "../PortalForms/Document";
import {
  getFilterAllSubcontractors, getFilterAllSubcontractors2, receivedSubcontractorById, subsCurrentWfTaskReceived,
  loadSubcontractorBprmForm, getSubcontractorBprmForm
} from "../../app/store/subcontractor";
import {
  getFilterAllRecruiters, getFilterAllRecruiters2, recCurrentWfTaskReceived,
  loadRecruiterBprmForm, getRecruiterBprmForm
} from "../../app/store/recruiter";
import WorkflowElement from "../../app/components/WorkflowElement";
import AchInformation from "../../ReviewTools/AchInformation";
import { formLibraryReceived } from "../../app/store/forms";
import PurchaseOrderPopup from "../../ReviewTools/PurchaseOrderPopup";
import { documentReceived, esignDocumentsReceived, reqDocumentReceived, loadDocuments, loadReqDocuments, getDocuments, getReqDocuments } from "../../app/store/documents";
import RateEncryptDecrypt from "../../services/RateEncryptDecrypt";
import { purchaseOrdersReceived, getPurchaseOrders, loadPurchaseOrders } from "../../app/store/purchaseOrder";
import { repositoryDocumentsReceived } from "../../app/store/ddrmsDocument";
import {
  getAgenciesPartners, getRecruiterPartners, getSubcontractorPartners, loadAgencies,
  loadRecruiterPartners, loadSubcontractorPartners
} from "../../app/store/partner";
import _, { set } from "lodash";

const getDynamicTabTitle = (uploadType, selectedCandidateId) => {
  if (!uploadType) return "Documents";
  const typeLower = uploadType.toLowerCase();
  if (typeLower === "agency") return "Agency Documents";
  if (typeLower === "candidate" && selectedCandidateId > 0) return "Candidate Documents";
  if (typeLower === "subcontractor") return "Subcontractor Documents";
  if (typeLower === "recruiter") return "Recruiter Documents";
  if (typeLower === "msp") return "MSP Documents";
  return "Documents";
};

const getDocsCountForApp = (applicantObj, appDocSelector, reqDocSelector) => {
  if (!applicantObj) return 0;

  const appDocs = (appDocSelector || []).filter((x) => x.uploadType !== "req");
  const reqDocs = reqDocSelector || [];

  const filterDocs = appDocs.filter(
    (x) => x.updType !== "Messaging" && x.deleteFlag !== true
  );

  const sentDocuments = filterDocs.filter(
    (x) => x.deleteFlag !== true && x.uploaderId !== applicantObj?.performerid
  );

  const filterReqDocs = reqDocs.filter(
    (x) => x.performerId === applicantObj?.performerid
  );

  const sentCount = sentDocuments.filter(
    (x) =>
      x.uploadType !== "client" &&
      x.uploadType !== "reporting" &&
      x.uploadType !== "project" &&
      x.uploadType !== "agency" &&
      x.uploadType !== "msp" &&
      x.uploadType !== "ProjectInfo" &&
      x.updType !== "internal" &&
      x.updType !== "Invoice" &&
      !(x.updType && x.updType.includes("req_"))
  ).length;

  return sentCount + filterReqDocs.length;
};

const getTwoLetterInitials = (name, fallback = "CN") => {
  if (!name || !name.trim()) return fallback;
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) {
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  }
  return name.trim().substring(0, 2).toUpperCase();
};

const CandidateAvatar = ({ candidate }) => {
  const dispatch = useDispatch();
  const profilePicsByUserId = useSelector(getUserProfilePicsById);
  const [imageFailed, setImageFailed] = useState(false);
  const candidateId = candidate?.performerid;
  const candidateName = [candidate?.performername, candidate?.lastName]
    .filter(Boolean)
    .join(" ");
  const profilePic = candidateId ? profilePicsByUserId[candidateId] : null;

  useEffect(() => {
    setImageFailed(false);
    if (candidateId) {
      dispatch(loadUserProfilePicById(candidateId, true));
    }
  }, [dispatch, candidateId]);

  const imageUrl = profilePic
    ? `${process.env.REACT_APP_API_BASEURL}/ProfilePics/${profilePic}`
    : null;

  return (
    <div className="wf-avatar-circle" title={candidateName || "Candidate"}>
      {imageUrl && !imageFailed ? (
        <img
          className="wf-avatar-image"
          src={imageUrl}
          alt={candidateName ? `${candidateName} profile` : "Candidate profile"}
          onError={() => setImageFailed(true)}
        />
      ) : (
        getTwoLetterInitials(candidateName)
      )}
    </div>
  );
};

export default function ListCondidate(props) {

  const currentUser = getCurrentUser();
  const [applicantType, setApplicantType] = useState("candidate");
  const [actionType, setActionType] = useState("");
  const [candidates, setCandidates] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);
  const [applicantCount, setApplicantCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);

  const [showHide, setShowHide] = useState(false);
  const [logShowHide, setLogShowHide] = useState(false);
  const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);
  const [viewShowHide, setViewShowHide] = useState(false);
  const [durationShowHide, setDurationShowHide] = useState(false);
  const [docShowHide, setDocShowHide] = useState(false);

  const [selectedObj, setSelectedObj] = useState("");
  const [viewType, setViewType] = useState("");
  const [editDurType, setEditDurType] = useState("");

  const [canId, setCanId] = useState("");
  const [canName, setCanName] = useState("");
  const [canEmail, setCanEmail] = useState("");
  const [canEntity, setCanEntity] = useState("");
  const [canSubcontractor, setCanSubcontractor] = useState("");
  const [canRecruiter, setCanRecruiter] = useState("");
  const [canAgency, setCanAgency] = useState("");

  const [dataType, setDataType] = useState("");
  const [selectedCandidateId, setSelectedCandidateId] = useState(0);
  const [pendingCandidateSelectionId, setPendingCandidateSelectionId] = useState(0);
  const [selectedKey, setSelectedKey] = useState(-1);
  const [infoApp, setInfoApp] = useState("");
  const [wfflowtask, setWfflowtask] = useState("");
  const [infoItem, setInfoItem] = useState("");
  const [selectedInfo, setSelectedInfo] = useState("");
  const [SelectedFormKey, setSelectedFormKey] = useState(-1);
  const [selectedTabKey, setSelectedTabKey] = useState("home");
  const [appDocuments, setAppDocuments] = useState([]);
  const [selectedCurrentTask, setSelectedCurrentTask] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [viewFormData, setviewFormData] = useState({});
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [wfId, setWfId] = useState(0);

  const [entityType, setEntityType] = useState(null);
  const [w2Type, setW2type] = useState(null);
  const [candidateObj, setCandidateObj] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [viewFormType, setViewFormType] = useState("");
  const [viewFormTabTitle, setViewFormTabTitle] = useState("");
  const [fetchedDataType, setFetchedDataType] = useState("");
  const [viewBprmFormShowHide, setViewBprmFormShowHide] = useState(false);
  const [achType, setAchType] = useState("");
  const [purchaseShowHide, setPurchaseShowHide] = useState(false);
  const [poOrderType, setPoOrderType] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [contractDocType, setContractDocType] = useState("");
  const [docUploadType, setDocUploadType] = useState("Candidate");

  const [filterSubcontractorList, setFilterSubcontractorList] = useState([]);
  const [filterRecruiterList, setFilterRecruiterList] = useState([]);
  const [filterAgencyList, setFilterAgencyList] = useState([]);
  const [filterCandidateList, setFilterCandidateList] = useState([]);
  const [filterShowHide, setFilterShowHide] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);


  const allCandidates = useSelector(getAllCandidates);
  const filterAllCandidates = useSelector(getFilterAllCandidates);
  const remiderStatus = useSelector(getReminderStatus);
  const filterAllSubcontractors = useSelector(getFilterAllSubcontractors);
  const filterAllSubcontractors2 = useSelector(getFilterAllSubcontractors2);
  const filterAllRecruiters = useSelector(getFilterAllRecruiters);
  const filterAllRecruiters2 = useSelector(getFilterAllRecruiters2);
  const purchaseOrdersSelector = useSelector(getPurchaseOrders);
  const candidateAppsSelector = useSelector(getCandidateApps);

  const candidateBprmFormSelector = useSelector(getCandidateBprmForm);
  const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm);
  const getfilterStatus = useSelector(getFilterCandidatesStatus)

  const subcontractorPartnersSelector = useSelector(getSubcontractorPartners);
  const recruiterPartnersSelector = useSelector(getRecruiterPartners);
  const agenciesPartnersSelector = useSelector(getAgenciesPartners);
  const candidateNameListSelector = useSelector(getCandidateNameList);

  const appDocumentSelector = useSelector(getDocuments);
  const reqDocumentsSelector = useSelector(getReqDocuments);

  const docsCount = getDocsCountForApp(selectedObj, appDocumentSelector, reqDocumentsSelector);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const restoredCandidateList = location.state?.restoreCandidateList
    ? (location.state.candidateListState || { currentPage: 1, pageSize: 5, dataType: "" })
    : null;
  const restoredFilterEffectHandled = useRef(false);
  const didSkipInitialCandidates = useRef(false);
  const didSkipInitialFilteredCandidates = useRef(false);
  const tableScrollRef = useRef(null);
  const topTableScrollRef = useRef(null);
  const tableDragStateRef = useRef({
    isDragging: false,
    startX: 0,
    scrollLeft: 0,
    hasDragged: false,
  });
  const tableClickSuppressRef = useRef(false);
  const [tableScrollWidth, setTableScrollWidth] = useState(0);
  const [hasTableHorizontalScroll, setHasTableHorizontalScroll] = useState(false);

  const candidateEntity = [
    { id: 1, name: "C2C Basis" },
    { id: 2, name: "1099 Basis" },
    { id: 3, name: "W2 Basis" },
  ];

  const param = useParams();
  const [type = "", candidateType = ""] = (param?.type || "").split("-");
  const candidateTableColSpan = {
    application: 10,
    partner: 5,
    timelog: 3,
    invoice: 3,
  }[type] || 11;

  useEffect(() => {
    let route = [
      { name: "Onboarding and Contracts", url: "" }
    ];
    let pgTitle = "Candidates";
    if (type === "partner") {
      route = [
        { name: "System Administration", url: "" },
        { name: "Manage Entities", url: "" },
      ];
    }

    if (type === "timelog" || type === "invoice") {
      route = [{ name: "Invoices", url: "" }];
      if (type === "timelog") pgTitle = "Time Log Management";
      if (type === "invoice") pgTitle = "Invoices and Payments";
    }
    if (candidateType === "c2c")
      setCanEntity("C2C Basis");

    if (candidateType === "w2")
      setCanEntity("W2 Basis");

    if (candidateType === "1099")
      setCanEntity("1099 Basis");

    dispatch(setCurrentRoute(route));
    dispatch(setCurrentPageTitle(pgTitle));
  }, [type, candidateType, dispatch])

  useEffect(() => {
    // dispatch(loadSubcontractorPartners("Sub-Contractors"));
    // dispatch(loadRecruiterPartners("Recruiter"));
    // dispatch(loadAgencies())
  }, []);

  useEffect(() => {
    setFilterSubcontractorList(subcontractorPartnersSelector);
  }, [subcontractorPartnersSelector])

  useEffect(() => {
    setFilterRecruiterList(recruiterPartnersSelector);
  }, [recruiterPartnersSelector])

  useEffect(() => {
    setFilterCandidateList(candidateNameListSelector)
  }, [candidateNameListSelector])

  useEffect(() => {
    const list = _.unionBy(agenciesPartnersSelector, "title")?.filter(x => x.title && x.title !== "");
    setFilterAgencyList(list);
  }, [agenciesPartnersSelector])

  useEffect(() => {
    setSelectedTabKey("home");
    setSelectedKey(-1);
    setSelectedCandidateId(0);
    setSelectedObj("")
  }, [type])

  useEffect(() => {
    if (getfilterStatus === "") {
      if (restoredCandidateList && allCandidates.length > 0) {
        const restoredPageSize = restoredCandidateList.pageSize || pageSize;
        const restoredPage = restoredCandidateList.currentPage || currentPage;
        setDataType("");
        setPageSize(restoredPageSize);
        setCurrentPage(restoredPage);
        setRowsCount(allCandidates[0]?.totalApplicants || 0);
        setCandidates(allCandidates);
        setIsTableLoading(false);
        return;
      }

      handleLoadFilterCandidates(pageSize, 1);
    } else if (getfilterStatus.dataType === "filter") {
      setCanId(getfilterStatus.id);
      setCanName(getfilterStatus.name);
      setCanEmail(getfilterStatus.email);
      setCanEntity(getfilterStatus.entity);
      setDataType("filter");

      if (restoredCandidateList && filterAllCandidates.length > 0) {
        const restoredPageSize = restoredCandidateList.pageSize || pageSize;
        const restoredPage = restoredCandidateList.currentPage || currentPage;
        setPageSize(restoredPageSize);
        setCurrentPage(restoredPage);
        getPagedData(filterAllCandidates, restoredPage, restoredPageSize);
      }


    }
  }, [candidateType]);

  useEffect(() => {
    if (selectedTabKey === "home") {
      // handleLoadFilterCandidates(pageSize, 1);
      if (!pendingCandidateSelectionId) {
        setSelectedObj("")
        setSelectedCandidateId(0)
      }
      dispatch(selectedCandidateObjReceiveClear())
    }
  }, [selectedTabKey, pendingCandidateSelectionId])

  const handleLoadFilterCandidates = (pages, index) => {
    setIsTableLoading(true);

    if (candidateType === "c2c")
      dispatch(loadCandidates(pages, index, applicantType + "-C2C Basis"));

    if (candidateType === "w2")
      dispatch(loadCandidates(pages, index, applicantType + "-W2 Basis"));

    if (candidateType === "1099")
      dispatch(loadCandidates(pages, index, applicantType + "-1099 Basis"));

    if (candidateType === "")
      dispatch(loadCandidates(pages, index, applicantType));
  }

  const handleAddEditCandidate = (candidateId = 0) => {
    if (candidateId > 0) {
      setPendingCandidateSelectionId(candidateId);
      setSelectedTabKey("home");
      setDataType("");
      setCurrentPage(1);
      setPageSize(5);
      setStartIndex(0);
      setEndIndex(5);
      dispatch(filterAllCandidatesStatus(""));
      handleLoadFilterCandidates(5, 1);
      return;
    }

    if (dataType === "filter")
      handleFilter();
    else
      handleLoadFilterCandidates(pageSize, currentPage);
  }

  useEffect(() => {
    if (!didSkipInitialCandidates.current) {
      didSkipInitialCandidates.current = true;
      return;
    }

    if (getfilterStatus?.dataType === "filter") return;

    setRowsCount(allCandidates?.[0]?.totalApplicants || 0);
    setCandidates(allCandidates || []);
    setIsTableLoading(false);
    handleCloseDocumentView();
    if (pendingCandidateSelectionId > 0) {
      const pendingCandidate = (allCandidates || []).find(
        (item) => String(item.performerid) === String(pendingCandidateSelectionId)
      );
      if (pendingCandidate) {
        selectCandidateFromList(pendingCandidate);
        setPendingCandidateSelectionId(0);
      }
    }
  }, [allCandidates]);

  useEffect(() => {
    if (!didSkipInitialFilteredCandidates.current) {
      didSkipInitialFilteredCandidates.current = true;
      if (!restoredCandidateList && getfilterStatus?.dataType !== "filter") return;
    }

    if (restoredCandidateList && !restoredFilterEffectHandled.current) {
      restoredFilterEffectHandled.current = true;

      if (getfilterStatus?.dataType === "filter" && filterAllCandidates.length > 0) {
        const restoredPageSize = restoredCandidateList.pageSize || pageSize;
        const restoredPage = restoredCandidateList.currentPage || currentPage;
        setPageSize(restoredPageSize);
        setCurrentPage(restoredPage);
        getPagedData(filterAllCandidates, restoredPage, restoredPageSize);
      }

      return;
    }

    setPageSize(5);
    setCurrentPage(1);
    getPagedData(filterAllCandidates, 1, 5);
  }, [filterAllCandidates]);

  useEffect(() => {
    if (remiderStatus === "success") {
      getAlert("", "Reminder Sent Successfully", "success");
      if (dataType === "filter")
        getPagedData(filterAllCandidates, currentPage, pageSize);
      else
        handleLoadFilterCandidates(pageSize, currentPage);
    }
  }, [remiderStatus]);

  useEffect(() => {
    if (selectedTabKey !== "home") return;

    const scrollElement = tableScrollRef.current;
    if (!scrollElement) return;

    const updateTableScrollWidth = () => {
      setTableScrollWidth(scrollElement.scrollWidth);
      setHasTableHorizontalScroll(scrollElement.scrollWidth > scrollElement.clientWidth);
    };

    updateTableScrollWidth();

    const resizeObserver = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(updateTableScrollWidth)
      : null;

    if (resizeObserver) {
      resizeObserver.observe(scrollElement);
      if (scrollElement.firstElementChild) {
        resizeObserver.observe(scrollElement.firstElementChild);
      }
    }

    window.addEventListener("resize", updateTableScrollWidth);

    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      window.removeEventListener("resize", updateTableScrollWidth);
    };
  }, [candidates, isTableLoading, selectedTabKey, type, selectedKey, SelectedFormKey]);

  const syncHorizontalTableScroll = (targetRef, scrollLeft) => {
    const target = targetRef.current;
    if (target && target.scrollLeft !== scrollLeft) {
      target.scrollLeft = scrollLeft;
    }
  };

  const handleTopTableScroll = (e) => {
    syncHorizontalTableScroll(tableScrollRef, e.currentTarget.scrollLeft);
  };

  const handleTableScroll = (e) => {
    syncHorizontalTableScroll(topTableScrollRef, e.currentTarget.scrollLeft);
  };

  const isTableDragIgnored = (target) =>
    target.closest(
      "button, a, input, select, textarea, label, [role='button'], .dropdown-menu"
    );

  const stopTableDrag = () => {
    tableDragStateRef.current.isDragging = false;
    if (tableScrollRef.current) {
      tableScrollRef.current.classList.remove("is-dragging");
    }
  };

  const handleTableMouseDown = (e) => {
    const scrollElement = tableScrollRef.current;
    if (
      e.button !== 0 ||
      !scrollElement ||
      scrollElement.scrollWidth <= scrollElement.clientWidth ||
      isTableDragIgnored(e.target)
    ) {
      return;
    }

    tableDragStateRef.current = {
      isDragging: true,
      startX: e.clientX,
      scrollLeft: scrollElement.scrollLeft,
      hasDragged: false,
    };
    tableClickSuppressRef.current = false;
    scrollElement.classList.add("is-dragging");
  };

  const handleTableMouseMove = (e) => {
    const dragState = tableDragStateRef.current;
    const scrollElement = tableScrollRef.current;
    if (!dragState.isDragging || !scrollElement) return;

    const deltaX = e.clientX - dragState.startX;
    if (Math.abs(deltaX) > 4) {
      dragState.hasDragged = true;
      tableClickSuppressRef.current = true;
    }

    if (dragState.hasDragged) {
      e.preventDefault();
      scrollElement.scrollLeft = dragState.scrollLeft - deltaX;
      syncHorizontalTableScroll(topTableScrollRef, scrollElement.scrollLeft);
    }
  };

  const handleTableMouseUp = () => {
    stopTableDrag();
  };

  const handleTableClickCapture = (e) => {
    if (!tableClickSuppressRef.current) return;

    e.preventDefault();
    e.stopPropagation();
    tableClickSuppressRef.current = false;
  };

  const handlePageChange = (page) => {
    handleResetSelection();
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    if (dataType === "filter")
      getPagedData(filterAllCandidates, page, pageSize)
    else
      handleLoadFilterCandidates(pageSize, page);
  };


  const handlePageSizeChanged = ({ currentTarget }) => {
    handleResetSelection();
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    if (dataType === "filter")
      getPagedData(filterAllCandidates, currentPage, currentTarget.value);
    else
      handleLoadFilterCandidates(currentTarget.value, currentPage);
  };

  const handleModalShowHide = (obj, type) => {
    if (obj === "save") {
      if (dataType === "filter")
        handleFilter();
      else {
        setIsTableLoading(true);
        dispatch(loadCandidates(pageSize, currentPage, applicantType));
      }

    } else {
      setShowHide(!showHide);
      setSelectedObj(obj);
      setActionType(type);
    }
  };

  const handleViewShowHide = (obj, view, key) => {
    setSelectedObj(obj);
    setEditDurType("")
    setSelectedFormKey(-1)
    if (viewType === view) {
      setViewShowHide(false);
      setSelectedKey(-1);
      setViewType("");
      setEditDurType("none");
    }
    else {
      setViewShowHide(true);
      setViewType(view);
      setSelectedKey(key)
    }

  };

  const handleGoBackCan = () => {
    setSelectedTabKey("home");
  }

  const handleCandidateSaved = (candidateId, options = {}) => {
    if (!(candidateId > 0)) {
      if (options.goHome) handleGoBackCan();
      return;
    }

    if (options.goHome) {
      handleAddEditCandidate(candidateId);
      return;
    }

    setPendingCandidateSelectionId(candidateId);
  }

  const handleLogShowHide = (item, actionType) => {

    if (item === "save") {
      setLogShowHide(false);
      setSelectedObj("");
      setActionType(actionType);

      if (dataType === "filter")
        handleFilter();
      else {
        setIsTableLoading(true);
        dispatch(loadCandidates(pageSize, currentPage, applicantType));
      }

    } else {
      setLogShowHide(!logShowHide);
      setSelectedObj(item);
      setActionType(actionType);

    }
  };

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    setRowsCount(items?.[0]?.totalApplicants || list?.[0]?.totalApplicants || list?.length || 0);

    setCandidates(items);
    setIsTableLoading(false);
    handleCloseDocumentView();
  };

  const handleRemainder = async (id) => {
    dispatch(SendReminder(id));
  };

  const handleRemainderMessage = () => {
    setRemainderMsgShowHide(!remainderMsgShowHide)
  };

  const handleCandidateFilter = () => {
    handleCloseDocumentView();
    handleCloseViewForm();
    closeACHInsu();
    setSelectedFormKey(-1);
    setSelectedObj("");
    setViewShowHide(false);
    handleFilter();
  }

  const handleFilter = async () => {
    setDataType("filter");
    const frmBody = new FormData();
    frmBody.append("id", canId);
    frmBody.append("name", canName);
    frmBody.append("email", canEmail);
    frmBody.append("type", applicantType);
    frmBody.append("entity", canEntity);
    frmBody.append("subId", canSubcontractor);
    frmBody.append("recId", canRecruiter);
    frmBody.append("agency", canAgency);
    frmBody.append("filterType", "search");
    setIsTableLoading(true);
    dispatch(loadAllCandidatesByFilter(frmBody));
    dispatch(filterAllCandidatesStatus({
      "id": canId,
      "name": canName,
      "email": canEmail,
      "dataType": "filter",
      "entity": canEntity,
    }));
  };

  const handleRefresh = () => {
    candidates.forEach((candidate) => {
      if (candidate?.performerid) {
        dispatch(loadUserProfilePicById(candidate.performerid, true));
      }
    });

    if (dataType === "filter") handleFilter();
    else handleLoadFilterCandidates(pageSize, currentPage);
  };

  const handleFilterCancel = async (type) => {

    if (type === "close" && filterShowHide)
      setFilterShowHide(false);

    setDataType("");
    setCanId("");
    setCanName("");
    setCanEmail("");
    setCanEntity("");
    setCanSubcontractor("");
    setCanRecruiter("");
    setCanAgency("");
    setCurrentPage(1);
    setPageSize(5);
    setIsTableLoading(true);
    dispatch(loadCandidates(5, 1, applicantType))
    dispatch(filterAllCandidatesStatus(""));
    setViewFormType("");
    setViewFormTabTitle("");
    setSelectedKey(-1);
    setSelectedFormKey(-1);
    setEntityType("");
    setFetchedDataType("")
    setW2type(null);
    setWfTask(null);
    setWfId(0);
    setCandidateObj(null);
    setEditDurType("");
    closeACHInsu()
  };

  const handleDurationAndRateShowHide = (obj, type, key) => {
    setSelectedFormKey(-1);
    setFetchedDataType("ViewForm");
    setViewFormType("");
    setViewType("");
    if (fetchedDataType !== "ViewForm") {
      setEditDurType("");
      setSelectedKey(-1);
    }
    setSelectedObj(obj);
    setViewShowHide(false);
    if (type === "duration" || type === "rate") {
      setSelectedTabKey(type);
      setEditDurType(type);
      setSelectedCandidateId(obj.performerid);
    } else {
      if (editDurType === type) {
        setEditDurType("");
        setSelectedKey(-1);
      } else {
        setEditDurType(type);
        setSelectedKey(key);
      }
    }
  };

  const getDateOnly = (value) => {
    if (!value) return null;
    let date = null;

    if (value instanceof Date) {
      date = new Date(value);
    } else if (typeof value === "string") {
      const dateOnlyMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
      date = dateOnlyMatch
        ? new Date(Number(dateOnlyMatch[1]), Number(dateOnlyMatch[2]) - 1, Number(dateOnlyMatch[3]))
        : new Date(value);
    } else {
      date = new Date(value);
    }

    if (Number.isNaN(date.getTime())) return null;
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const isRateEffective = (rates, rateField, effectiveDateField) => {
    if (!rates?.[rateField]) return false;
    const effectiveDate = getDateOnly(rates?.[effectiveDateField]);
    if (!effectiveDate) return false;
    const today = getDateOnly(new Date());
    return effectiveDate <= today;
  };

  const shouldShowCandidateRate = (item) => isRateEffective(item?.rates, "candidateRate", "candidateEffectiveDate");
  const shouldShowAgencyRate = (item) => isRateEffective(item?.rates, "agencyRate", "agencyEffectiveDate");
  const shouldShowSubcontractorRate = (item) => isRateEffective(item?.rates, "subcontractorRate", "subcontractorEffectiveDate");
  const shouldShowRecruiterRate = (item) => isRateEffective(item?.rates, "recruiterRate", "recruiterEffectiveDate");
  const checkTerminateDuration = (item, key) => {
    if (item.duration === null) return "";
    if (item.duration?.terminateStatus)
      return (
        <button
          type="button"
          className="wf-tool-btn is-insurance"
          onClick={(e) => {
            e.stopPropagation();
            handleDurationAndRateShowHide(item, "terminated", key);
          }}
          title="Terminated status details"
        >
          Terminated
        </button>
      );
    const newStartDate = new Date();
    const newEndDate = new Date(item.duration?.endDate);
    const one_day = 1000 * 60 * 60 * 24;
    let result;
    result = Math.ceil(
      (newEndDate.getTime() - newStartDate.getTime()) / one_day
    );
    if (result < 45 && result > 0)
      return (
        <span
          className="wf-entity-badge basis-1099"
          style={{ padding: "6px 10px", fontSize: "12px", fontWeight: "500", fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}
        >
          Expiring Soon
        </span>
      );

    if (result < 0)
      return (
        <span
          className="wf-entity-badge"
          style={{ background: "#fef2f2", borderColor: "#fca5a5", color: "#b91c1c", padding: "6px 10px", fontSize: "12px", fontWeight: "500", fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}
        >
          Expired
        </span>
      );
    return "";
  };

  const handleViewApplication = (item, app) => {
    navigate("/ReviewTask", {
      state: {
        task: getLastWorkflowTask(app.workflowTasks),
        item,
        app,
        type: type,
        parentApplication: null,
        appType: "Candidate",
        module: "Candidate",
        returnTo: `/ListCondidate/${param?.type || "application"}`,
        candidateListState: {
          currentPage,
          pageSize,
          dataType,
        },
      }
    })
  }

  const getLastWorkflowTask = (workflowTasks) => {
    const allTasks = workflowTasks.filter(
      (x) =>
        x.itemType === 1 &&
        x.applicantId !== x.performerId &&
        x.taskDoneStatus > 0
    );
    if (allTasks.length === 0) {
      return workflowTasks[workflowTasks.length - 1];
    }
    const tsk = allTasks[allTasks.length - 1];
    return tsk;
  };

  const handleViewCandidateDetails = (item, type) => {
    navigate("/CandidateDetails", {
      state: {
        item,
        type,
        candidateListState: {
          currentPage,
          pageSize,
          dataType,
        }
      }
    });
  }

  const handleOpenPartnerList = (partnerKind, item) => {
    const partner = partnerKind === "subcontractor" ? item?.subcontractor : item?.recruiter;
    if (!partner) return;

    navigate(
      partnerKind === "subcontractor"
        ? "/ListSubcontractor/application"
        : "/Recruiter/application",
      {
        state: {
          fromCandidateList: true,
          returnTo: `/ListCondidate/${param?.type || "application"}`,
          candidateListState: {
            currentPage,
            pageSize,
            dataType,
          },
          partnerListFilter: {
            id: partner.fuid || "",
            name: partner.label || "",
            email: partner.email || "",
          },
        },
      }
    );
  }

  const handleResetSelection = () => {
    setSelectedCandidateId(0);
    setSelectedObj(null);
    setSelectedApp(null);
    setSelectedCurrentTask(null);
    setDocUploadType("Candidate");
    if (["contracts", "ach", "purchaseOrder", "duration", "rate"].includes(selectedTabKey)) {
      setSelectedTabKey("home");
    }
    dispatch(documentReceived([]));
    dispatch(reqDocumentReceived([]));
  }

  const selectCandidateFromList = (item) => {
    setSelectedCandidateId(item.performerid);
    setSelectedObj(item);
    if (item?.applications?.length > 0) {
      const app = item.applications[0];
      setSelectedApp(app);
      const wfTask = getLastWorkflowTask(app?.workflowTasks);
      setSelectedCurrentTask(wfTask);
      if (wfTask?.ciid > 0) {
        dispatch(loadDocuments(wfTask.ciid));
        dispatch(loadReqDocuments(wfTask.ciid));
      }
      if (item.subcontractor?.fuid > 0 || item.recruiter?.fuid > 0) {
        dispatch(loadPurchaseOrders(item.performerid));
      }
    }
  }

  const handleSelectCandidate = (item) => {
    if (selectedCandidateId === item.performerid) {
      handleResetSelection();
    } else {
      selectCandidateFromList(item);
    }
  }

  const handleWorkflowPanelOpen = (tab, item, app, docType = "Candidate") => {
    setSelectedCandidateId(item.performerid);
    setSelectedObj(item);
    setSelectedApp(app);
    setDocUploadType(docType);
    const wfTask = getLastWorkflowTask(app?.workflowTasks);
    setSelectedCurrentTask(wfTask);
    setSelectedTabKey(tab);
    if (wfTask?.ciid > 0) {
      dispatch(loadDocuments(wfTask.ciid));
      dispatch(loadReqDocuments(wfTask.ciid));
    }
    if (item.subcontractor?.fuid > 0 || item.recruiter?.fuid > 0) {
      dispatch(loadPurchaseOrders(item.performerid));
    }
  };

  const renderSelectedCandidateContextCard = () => {
    if (!(selectedCandidateId > 0 && selectedObj)) return null;

    return (
      <div
        className="wf-assign-card"
        style={{ marginTop: 8, marginBottom: 14 }}
      >
        <div className="wf-assign-info">
          <div className="wf-assign-avatar">
            {getInitial(`${selectedObj.performername || ""} ${selectedObj.lastName || ""}`).substring(0, 2)}
          </div>
          <div className="wf-assign-meta">
            <strong>
              {selectedObj.performername} {selectedObj.lastName}
            </strong>
            <span>
              <i className="fa fa-hashtag" style={{ marginRight: 4 }} />
              ID: #{selectedObj.performerid}
              {selectedObj.maxloans && (
                <>
                  &nbsp;&bull;&nbsp;
                  IPCS: #{selectedObj.maxloans}
                </>
              )}
              {selectedObj.performeremail && (
                <>
                  &nbsp;&bull;&nbsp;
                  <i className="fa fa-envelope-o" style={{ marginRight: 4 }} />
                  {selectedObj.performeremail}
                </>
              )}
              {selectedObj.contactNo && (
                <>
                  &nbsp;&bull;&nbsp;
                  <i className="fa fa-phone" style={{ marginRight: 4 }} />
                  {getFormatedNumber(selectedObj.contactNo)}
                </>
              )}
            </span>
          </div>
        </div>
        <div className="wf-assign-actions">
          {type === "partner" && (
            <button
              className="btn-action-search"
              onClick={() => setSelectedTabKey("status")}
            >
              <i className="fa fa-toggle-on" /> Activate/Deactivate
            </button>
          )}
          <button
            className="btn-action-search btn-danger-search"
            onClick={handleResetSelection}
          >
            <i className="fa fa-times" />
          </button>
        </div>
      </div>
    );
  };

  const getCandidateActivationStatus = (item) => {
    if (item?.isActive === true) {
      return {
        label: "Activated",
        icon: "fa-check-circle",
        className: "is-complete",
      };
    }
    if (item?.isActive === false) {
      return {
        label: "Deactivated",
        icon: "fa-times-circle",
        className: "is-danger",
      };
    }
    return { label: "To activate", icon: "fa-clock-o", className: "is-muted" };
  };

  const getInitial = (name) => {
    return getTwoLetterInitials(name);
  };

  const getProjectValue = (item, fields) =>
    fields
      .map((field) => getFieldData(item.performerData, "projectengagement", field))
      .find((value) => value && value !== "");

  const getOnboardingFormTitle = (formType) => {
    if (formType === "Agency") return "Agency/Client Form";
    if (formType === "MSP") return "MSP Form";
    if (formType === "Subcontractor") return "Subcontractor Form";
    if (formType === "Recruiter") return "Recruiter Form";
    return "Onboarding Form";
  };

  const getAddressLines = (item) => {
    const line1 = getFieldData(item?.performerData, "candidateonboardingform", "Current_Address_Line1") || "";
    const line2 = getFieldData(item?.performerData, "candidateonboardingform", "Current_Address_Line2") || "";
    const firstLine = [line1, line2].filter(Boolean).join(", ");
    const secondLine = [
      getFieldData(item?.performerData, "candidateonboardingform", "Current_City"),
      getFieldData(item?.performerData, "candidateonboardingform", "Current_State"),
      getFieldData(item?.performerData, "candidateonboardingform", "Current_Zip_Code")
    ]
      .filter(Boolean)
      .join(", ");

    return [firstLine, secondLine].filter(Boolean);
  };

  const handleViewcandidateForm = (type, key, item) => {
    if (viewFormType === type && SelectedFormKey === key && selectedTabKey === "onboardingForm") return;

    setSelectedKey(-1);
    setViewFormType(type);
    setViewFormTabTitle(getOnboardingFormTitle(type));
    setFetchedDataType("Form")
    setSelectedFormKey(key);
    setCandidateObj(item);
    setSelectedObj(item);
    setSelectedCandidateId(item.performerid);
    setSelectedTabKey("onboardingForm");
    setViewShowHide(false);
    setEditDurType("");
    setWfForm(null);
    setWfTask(null);

    if (type === "Candidate") {
      const entType = getFieldData(item.performerData, "candidateonboardingform", "CandidateEntity");
      const w9type = getFieldData(item.performerData, "candidateonboardingform", "w9_Type");
      setEntityType(entType);
      setW2type(w9type);
      dispatch(candidateBprmFormReceived(null));
      setCandidateType(entType, item);
    }
    if (type === "Subcontractor") {
      const subcontractorObj = item?.subcontractor;
      let appCiid = 0;
      if (subcontractorObj?.applications?.length > 0) {
        const allWfTasks = subcontractorObj.applications[0].workflowTasks;
        if (allWfTasks?.length > 0) {
          appCiid = allWfTasks[allWfTasks.length - 1].ciid;
        }
      }
      setWfTask({ formId: config.formIds.subcontractor, ciid: appCiid });
      dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor));
    }
    if (type === "Recruiter") {
      const recruiterObj = item?.recruiter;
      let appCiid = 0;
      if (recruiterObj?.applications?.length > 0) {
        const allWfTasks = recruiterObj.applications[0].workflowTasks;
        if (allWfTasks?.length > 0) {
          appCiid = allWfTasks[allWfTasks.length - 1].ciid;
        }
      }
      setWfTask({ formId: config.formIds.recruiter, ciid: appCiid });
      dispatch(loadRecruiterBprmForm(config.formIds.recruiter));
    }
  }

  const handleCloseViewForm = () => {
    setViewFormType("");
    setViewFormTabTitle("");
    setFetchedDataType("");
    setSelectedFormKey(-1);
    setWfTask(null);
    setWfId(0);
    setCandidateObj(null);
    setEntityType("");
    setW2type(null);
    setWfForm(null);
    dispatch(candidateBprmFormReceived(null));
  }

  const setCandidateType = (entType, sourceCandidate = candidateObj) => {
    let appCiid = 0;
    if (sourceCandidate?.applications?.length > 0) {
      const allWfTasks = sourceCandidate?.applications[0].workflowTasks;
      if (allWfTasks?.length > 0) {
        appCiid = allWfTasks[allWfTasks.length - 1].ciid;
      }
    }
    if (entType === "C2C Basis") {
      setWfTask({ formId: config.formIds.candidate.C2C_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.C2C_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.C2C_Basis))
    }
    if (entType === "W2 Basis") {
      setWfTask({ formId: config.formIds.candidate.W2_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.W2_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.W2_Basis));
    }
    if (entType === "1099 Basis") {
      setWfTask({ formId: config.formIds.candidate.Ten_99_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.Ten_99_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.Ten_99_Basis))
    }
  }

  useEffect(() => {
    if (candidateObj) {
      if (candidateObj.applications?.length > 0) {
        setUpdatedStateData(candidateObj.applications[0].applicationData);
      }
      else {
        setUpdatedStateData(candidateObj.performerData)
      }
    } else {
      setUpdatedStateData(null);
    }
  }, [candidateObj])

  useEffect(() => {
    if (viewFormType === "Candidate") {
      setWfForm(candidateBprmFormSelector);
    } else if (viewFormType === "Subcontractor") {
      setWfForm(subcontractorBprmFormSelector);
    } else if (viewFormType === "Recruiter") {
      setWfForm(recruiterBprmFormSelector);
    }
  }, [candidateBprmFormSelector, subcontractorBprmFormSelector, recruiterBprmFormSelector, viewFormType]);

  const handlePermissionShowHide2 = () => {
    setIsTableLoading(true);
    dispatch(loadCandidates(pageSize, currentPage, applicantType))
    setSelectedTabKey("home")
  };

  const setCanEntityFunc = (value) => {
    setCanEntity(value)
    setDataType("")
  }

  const handleDocumentViewShowHide = (type, key, app, item) => {
    if (editDurType === type) return;
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    if (!tsk) {
      setTimeout(() => {
        setSelectedCurrentTask(tsk);
        closeACHInsu()
        setSelectedFormKey(-1)
        setSelectedKey(key);
        setEditDurType(type);
        setViewShowHide(false);
        setSelectedApp(app);
        setFetchedDataType("Document");
        setCandidateObj(item);
      }, 1000);
    }
    else {
      setSelectedCurrentTask(tsk);
      closeACHInsu()
      setSelectedFormKey(-1)
      setSelectedKey(key);
      setEditDurType(type);
      setViewShowHide(false);
      setSelectedApp(app);
      setFetchedDataType("Document");
      setCandidateObj(item);
    }

  };

  const handleCloseDocumentView = () => {
    console.log("candidatelist")
    setFetchedDataType("");
    setSelectedKey(-1);
    setSelectedCurrentTask(null);
    setSelectedApp(null);
    setEditDurType("");
    setCandidateObj(null);
    dispatch(documentReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(formLibraryReceived([]));
    dispatch(reqDocumentReceived([]));
    dispatch(esignDocumentsReceived([]));
    dispatch(purchaseOrdersReceived([]));
    dispatch(repositoryDocumentsReceived([]));
    dispatch(candidateAppsReceived([]))
  }

  useEffect(() => {
    if (candidateAppsSelector.length > 0) {
      const latestApp = candidateAppsSelector[0];
      setInfoApp(latestApp);
      setWfflowtask(getLastWorkflowTask(latestApp?.workflowTasks))
    }
  }, [candidateAppsSelector]);

  const closeACHInsu = () => {
    setSelectedInfo("");
    setSelectedKey(-1);
    setAchType("");
  }

  const handleACHShowHide = (mod, type, item, key, app) => {
    console.log("candidatelist")
    if (achType === type) return;
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedCandidateById([]));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    setSelectedInfo(mod);
    setSelectedKey(key);
    setFetchedDataType("")
    setEditDurType("");
    setAchType(type);
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  }

  const handleNextTask = () => {
    console.log("")
  }

  const getAdminMspFee = (item) => {
    const feePer = getFieldData(
      item.performerData,
      "candidateonboardingform",
      "Msp_AdminFee"
    );

    // const feeDo = getFieldData(
    //   item.performerData,
    //   "candidateonboardingform",
    //   "Msp_TechFee"
    // )

    let mspData = <div> {feePer !== "" && feePer !== "0" && <> Admin Fee : <b>{feePer}%</b></>} </div>;
    return mspData;
  }

  const getAdminAgencyFee = (item) => {
    const feePer = getFieldData(
      item.performerData,
      "projectengagement",
      "State_Admin_Fee"
    );

    const feeDo = getFieldData(
      item.performerData,
      "projectengagement",
      "State_Admin_Fee_Amount"
    )

    if (feePer !== "" && feePer !== "0") {
      return <>State Admin Fee : <RateEncryptDecrypt rateData={feePer} startSymbol="" endSymbol="%" /></>
    }
    else if (feeDo !== "" && feeDo !== "0") {
      return <>State Admin Fee : <RateEncryptDecrypt rateData={feeDo} /></>
    }

    return "";
  }

  const handlePurchaseShowHide = (item, type, poType) => {
    setPurchaseShowHide(!purchaseShowHide);
    setCandidateObj(item);
    setPoOrderType(type);
    setSelectedItem({ partnerType: poType })
    if (item?.applications?.length > 0) {
      const tsk = item.applications[0].workflowTasks[item.applications[0].workflowTasks.length - 1];
      setSelectedCurrentTask(tsk);
    }

  };

  const handleSignUnsignPo = (unSignPo) => {
    //setPoCount(unSignPo);
  }

  const handleRefreshPoOrders = () => {
    // if (item?.partnerId)
    //   dispatch(loadPartnerPerformers(item.partnerId));
  }

  const handleSearchShowHide = () => {
    setFilterShowHide(!filterShowHide);
    if (!filterShowHide) {
      if (subcontractorPartnersSelector.length === 0)
        dispatch(loadSubcontractorPartners("Sub-Contractors"));
      if (recruiterPartnersSelector.length === 0)
        dispatch(loadRecruiterPartners("Recruiter"));
      if (agenciesPartnersSelector.length === 0)
        dispatch(loadAgencies())
      if (candidateNameListSelector.length === 0) {
        let pmId = 0;
        if (canEntity === "C2C Basis") pmId = 67;
        if (canEntity === "1099 Basis") pmId = 70;
        if (canEntity === "W2 Basis") pmId = 69;
        dispatch(loadCandidateNameList(pmId));
      }

    }
  }

  return (
    <React.Fragment>
      <style>{`
        @keyframes searchSlideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }

        @keyframes loadingBar {
          0%   { width: 0%; opacity: 1; }
          70%  { width: 85%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }

        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        @keyframes rowFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-loading-bar {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #171717, #737373, #171717);
          background-size: 200% 100%;
          animation: loadingBar 1.6s ease-in-out infinite;
          z-index: 10;
        }

        .skeleton-cell {
          display: block;
          height: 13px;
          border-radius: 6px;
          background: linear-gradient(
            90deg,
            #f1f5f9 25%,
            #e2e8f0 50%,
            #f1f5f9 75%
          );
          background-size: 600px 100%;
          animation: shimmer 1.4s ease-in-out infinite;
        }

        .skeleton-cell.sk-short  { width: 40%; }
        .skeleton-cell.sk-medium { width: 65%; }
        .skeleton-cell.sk-long   { width: 85%; }
        .skeleton-cell.sk-full   { width: 92%; }
        .skeleton-cell.sk-avatar {
          width: 34px;
          height: 34px;
          border-radius: 10px;
          flex: 0 0 auto;
        }

        .skeleton-row td {
          padding: 14px 16px !important;
        }

        .skeleton-identity {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .skeleton-stack {
          display: flex;
          flex-direction: column;
          gap: 8px;
          width: 100%;
        }

        .wf-assign-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: 20px 24px;
          background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%);
          border: 1px solid rgba(37,99,235,0.12);
          border-radius: 14px;
          margin: 16px 0;
          flex-wrap: wrap;
          animation: searchSlideDown 0.3s ease both;
        }

        .wf-assign-info {
          display: flex;
          align-items: center;
          gap: 14px;
          min-width: 0;
        }

        .wf-assign-avatar {
          width: 44px;
          height: 44px;
          border-radius: 0;
          background: linear-gradient(135deg, #0f766e, #2563eb);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 14px;
          font-weight: 500;
          flex-shrink: 0;
        }

        .wf-assign-meta strong {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          margin-bottom: 3px;
          text-transform: uppercase;
        }

        .wf-assign-meta span {
          display: inline-flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
          font-size: 12px;
          font-weight: 400;
          color: #64748b;
        }

        .wf-assign-actions {
          display: flex;
          gap: 8px;
          align-items: center;
          flex-wrap: wrap;
        }

        .wf-assign-actions .btn-action-search {
          height: auto !important;
          min-height: 32px !important;
          box-sizing: border-box !important;
          justify-content: center !important;
        }

        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 0 !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          min-height: 420px !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          font-size: 14px !important;
        }

        .wf-card-header-bar {
          position: relative !important;
          overflow: hidden !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 12px !important;
          padding: 14px 20px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          background: #ffffff !important;
          border-radius: 0 !important;
          flex: 0 0 auto !important;
        }

        .wf-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }

        .wf-stats-chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: transparent;
          border: 1px solid rgba(100, 116, 139, 0.18);
          color: #1e293b;
          border-radius: 0;
          padding: 5px 12px;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.2px;
        }

        .wf-stats-chip i {
          font-size: 14px;
          color: #1e293b;
        }

        .search-panel-collapse {
          background: #ffffff !important;
          border: 1px solid rgba(203, 213, 225, 0.7) !important;
          border-radius: 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          animation: searchSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
          margin-top: 12px !important;
          margin-bottom: 8px !important;
          overflow: hidden !important;
        }

        .sp-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 20px 12px;
          border-bottom: 1px solid rgba(226, 232, 240, 0.8);
          background: #ffffff !important;
        }

        .sp-header-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          letter-spacing: 0.1px;
        }

        .sp-header-title i {
          color: #64748b;
          font-size: 14px;
        }

        .sp-header-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          background: rgba(37, 99, 235, 0.07);
          border: 1px solid rgba(37, 99, 235, 0.15);
          color: #1d4ed8;
          border-radius: 0;
          padding: 3px 10px;
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.3px;
          text-transform: uppercase;
        }

        .search-panel-collapse input,
        .search-panel-collapse textarea,
        .search-panel-collapse select {
          font-weight: 400 !important;
        }
        .search-panel-collapse input::placeholder,
        .search-panel-collapse textarea::placeholder {
          font-weight: 400 !important;
          color: #94a3b8 !important;
        }
        .search-panel-collapse [class*="-placeholder"] {
          font-weight: 400 !important;
          color: #94a3b8 !important;
        }

        .sp-body {
          padding: 18px 20px 14px;
        }

        .sp-footer {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 20px;
          border-top: 1px solid rgba(226, 232, 240, 0.7);
          background: #ffffff;
        }

        .wf-control-label {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.7px !important;
          margin-bottom: 7px !important;
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .wf-control-label i {
          color: #94a3b8;
          font-size: 12px;
        }

        .wf-input-wrap {
          position: relative;
        }

        .wf-input-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 14px;
          pointer-events: none;
          transition: color 0.2s ease;
          z-index: 1;
        }

        .wf-input-wrap:focus-within .wf-input-icon {
          color: #2563eb;
        }

        .wf-input {
          border-radius: 10px !important;
          border: 1.5px solid #e2e8f0 !important;
          padding: 9px 14px 9px 36px !important;
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          height: auto !important;
          width: 100% !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
        }

        .wf-input::placeholder {
          color: #94a3b8 !important;
          font-weight: 400 !important;
        }

        .wf-input:hover {
          border-color: #94a3b8 !important;
          box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
        }

        .wf-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important;
          background: #fafbff !important;
        }

        .wf-select {
          appearance: none !important;
          -webkit-appearance: none !important;
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 14px center !important;
          padding-right: 36px !important;
        }

        .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }

        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }

        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          color: #ffffff !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }

        .btn-action-search.btn-danger-search {
          background: #ffffff !important;
          color: #991b1b !important;
          border: 1px solid #fca5a5 !important;
          box-shadow: 0 2px 5px rgba(220, 38, 38, 0.12) !important;
        }

        .btn-action-search.btn-danger-search:hover {
          background: #fff5f5 !important;
          color: #7f1d1d !important;
          border-color: #f87171 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(220, 38, 38, 0.16) !important;
        }

        .btn-action-search:disabled {
          background: #ffffff !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04) !important;
          opacity: 1 !important;
        }

        .btn-action-search.btn-primary-search:disabled {
          background: #e2e8f0 !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
          opacity: 1 !important;
        }

        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }

        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        .wf-reset-selection {
          background: rgba(37, 99, 235, 0.08) !important;
          border: 1px solid rgba(37, 99, 235, 0.2) !important;
          color: #2563eb !important;
          border-radius: 4px !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
        }

        .wf-reset-selection:hover {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          transform: translateY(-1px) !important;
        }

        /* ── Premium Tabs ─────────────────────────────── */
        .wf-tabs-container {
          display: flex;
          flex: 1 1 auto !important;
          flex-direction: column;
          min-height: auto !important;
          overflow: visible !important;
        }

        .wf-tab-bar {
          display: flex !important;
          align-items: stretch !important;
          gap: 4px !important;
          border-bottom: 2px solid #e5e5e5 !important;
          margin-bottom: 0 !important;
          padding: 8px 0 0 !important;
          position: relative !important;
          flex: 0 0 auto !important;
        }

        .wf-tab-btn {
          position: relative !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          border: none !important;
          background: transparent !important;
          padding: 9px 16px 11px !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          border-radius: 0 !important;
          transition: color 0.2s ease, background 0.2s ease !important;
          outline: none !important;
          white-space: nowrap !important;
        }

        .wf-tab-btn i {
          font-size: 14px !important;
          color: currentColor !important;
          transition: color 0.2s ease !important;
        }

        .wf-tab-btn:hover {
          color: #0f172a !important;
          background: #f5f5f5 !important;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #ffffff !important;
          font-weight: 500 !important;
          background: #171717 !important;
        }

        .wf-tab-btn.active i {
          color: #ffffff !important;
        }

        .wf-tab-btn::after {
          content: "" !important;
          position: absolute !important;
          bottom: -2px !important;
          left: 0 !important;
          right: 0 !important;
          height: 2px !important;
          background: #171717 !important;
          border-radius: 2px 2px 0 0 !important;
          transform: scaleX(0) !important;
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        .wf-tab-btn.active::after {
          transform: scaleX(0) !important;
        }

        .wf-tab-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          min-width: 20px !important;
          height: 20px !important;
          padding: 0 6px !important;
          border-radius: 999px !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          background: #f1f5f9 !important;
          color: #64748b !important;
          border: 1px solid #e2e8f0 !important;
          transition: all 0.2s ease !important;
          line-height: 1 !important;
        }

        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff !important;
          color: #171717 !important;
          border-color: #ffffff !important;
        }

        .wf-tab-btn.tab-locked .wf-tab-badge {
          background: rgba(245,158,11,0.1);
          color: #b45309;
          border-color: rgba(245,158,11,0.2);
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        .wf-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 48px 20px;
          color: #64748b;
          text-align: center;
        }

        .wf-empty-title {
          margin: 8px 0 4px;
          font-size: 14px;
          color: #1e293b;
          font-weight: 500;
        }

        .wf-empty-icon {
          width: 52px;
          height: 52px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          background: linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(15,118,110,0.06) 100%);
          color: #2563eb;
          border: 1px solid rgba(37,99,235,0.12);
        }

        .wf-empty-desc {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
          margin: 0 auto;
          line-height: 1.6;
          text-align: center;
          width: 100%;
        }

        .wf-identity-cell {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          min-width: 0;
        }

        .wf-avatar-stack {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          flex-shrink: 0;
        }

        .wf-avatar-circle {
          width: 40px;
          height: 40px;
          border-radius: 0;
          background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
          color: #ffffff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.5px;
          flex: 0 0 auto;
          box-shadow: 0 4px 10px rgba(15, 118, 110, 0.2);
          border: 2px solid #ffffff;
          outline: 1px solid #e2e8f0;
          overflow: hidden;
        }

        .wf-avatar-image {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }

        .wf-avatar-check-badge {
          position: absolute;
          top: -4px;
          right: -4px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #2563eb;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 8px;
          border: 1.5px solid #ffffff;
          box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3);
          z-index: 2;
          animation: scaleIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }

        @keyframes scaleIn {
          from {
            transform: scale(0);
          }
          to {
            transform: scale(1);
          }
        }

        .wf-identity-copy {
          display: flex;
          flex-direction: column;
          gap: 6px;
          min-width: 0;
          flex: 1;
        }

        .wf-identity-heading {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
        }

        .wf-identity-title,
        button.wf-identity-title {
          color: #1e293b !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          line-height: 1.3 !important;
          letter-spacing: 0.3px !important;
          text-transform: uppercase !important;
          white-space: normal !important;
          word-break: break-word !important;
          overflow-wrap: break-word !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
          padding: 0 !important;
          margin: 0 !important;
          outline: none !important;
        }

        .wf-identity-title:hover,
        button.wf-identity-title:hover {
          color: #2563eb !important;
          background: transparent !important;
          box-shadow: none !important;
          text-decoration: underline !important;
        }

        .wf-identity-meta-row {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          color: #64748b;
          font-size: 12px;
          font-weight: 400;
          line-height: 1.45;
        }

        .wf-row-actions {
          display: flex;
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 6px !important;
        }

        .wf-table i,
        .wf-table-modern i,
        .wf-status-pill i,
        .wf-app-status-badge i,
        .wf-link-action i,
        .btn-action-search i {
          display: inline-block !important;
          font-family: FontAwesome !important;
          font-style: normal !important;
          font-weight: normal !important;
          color: currentColor !important;
          visibility: visible !important;
          opacity: 1 !important;
        }

        .wf-identity-meta-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          border-radius: 5px;
          flex-shrink: 0;
          font-size: 10px;
          margin-top: 1px;
        }

        .wf-identity-meta-icon i {
          color: inherit !important;
          font-size: 10px !important;
          width: auto !important;
          text-align: center !important;
          flex-shrink: 0 !important;
        }

        .wf-icon-email {
          background: #eff6ff;
          color: #2563eb;
        }

        .wf-icon-calendar {
          background: #faf5ff;
          color: #7c3aed;
        }

        .wf-icon-address {
          background: #fff1f2;
          color: #e11d48;
        }

        .wf-icon-user {
          background: #f0fdf4;
          color: #16a34a;
        }

        .wf-icon-phone {
          background: #fff7ed;
          color: #ea580c;
        }

        .wf-icon-money {
          background: #ecfdf5;
          color: #047857;
        }

        .wf-icon-percent {
          background: #fef3c7;
          color: #b45309;
        }

        .wf-icon-client {
          background: #eef2ff;
          color: #4f46e5;
        }

        .wf-icon-calendar-start {
          background: #ecfdf5;
          color: #059669;
        }

        .wf-icon-calendar-end {
          background: #fff1f2;
          color: #e11d48;
        }

        .wf-icon-candidate {
          background: #eff6ff;
          color: #2563eb;
        }

        .wf-icon-building {
          background: #f0fdfa;
          color: #0f766e;
        }

        .wf-icon-recruiter {
          background: #f5f3ff;
          color: #7c3aed;
        }

        .wf-identity-meta-text {
          flex: 1;
          min-width: 0;
          white-space: nowrap;
          word-break: normal;
          overflow-wrap: normal;
        }

        .wf-identity-address-text {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .wf-inline-id {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          width: max-content;
          padding: 2px 6px;
          font-size: 12px;
          font-weight: 500;
          background: #eff6ff;
          border: 1px solid #dbeafe;
          color: #1d4ed8;
          border-radius: 0 !important;
          letter-spacing: 0.5px;
          line-height: 1;
        }

        .wf-avatar-stack > .wf-inline-id,
        .wf-partner-avatar-id {
          font-size: 13px !important;
          color: #1e293b !important;
        }

        /* Enhanced Applications Column Layout */
        .wf-app-name-card {
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 12px !important;
          padding: 12px 14px !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.02) !important;
          transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          flex-wrap: nowrap !important;
          width: 100%;
          box-sizing: border-box;
          cursor: pointer !important;
        }

        .wf-app-name-card:hover {
          border-color: #2563eb !important;
          box-shadow: 0 4px 16px -4px rgba(37, 99, 235, 0.15) !important;
          transform: translateY(-1px) !important;
          background: #fafbff !important;
        }

        .wf-app-actions-card {
          background: #ffffff !important;
          border: 1px solid #eef2f6 !important;
          border-radius: 12px !important;
          padding: 12px 14px !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
          transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex;
          flex-direction: column;
          gap: 8px;
          width: 100%;
          box-sizing: border-box;
        }

        .wf-app-actions-card:hover {
          border-color: #cbd5e1 !important;
          box-shadow: 0 4px 12px -2px rgba(15, 23, 42, 0.06) !important;
          transform: translateY(-1px) !important;
        }

        .wf-app-header-left {
          display: flex;
          align-items: center;
          gap: 6px;
          flex-wrap: nowrap !important;
          min-width: 0;
          flex: 1;
          overflow: hidden;
        }

        .wf-app-title-text {
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          letter-spacing: -0.2px;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          line-height: 1.4 !important;
        }

        .wf-app-title-text.is-link {
          cursor: pointer !important;
          color: #2563eb !important;
          text-decoration: none !important;
          transition: color 0.15s ease, text-decoration 0.15s ease !important;
        }

        .wf-app-title-text.is-link:hover {
          color: #1d4ed8 !important;
          text-decoration: underline !important;
        }

        .wf-app-id-text {
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          padding: 2px 5px !important;
          flex-shrink: 0 !important;
        }

        .wf-app-status-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          height: 22px !important;
          min-width: 82px !important;
          padding: 0 8px !important;
          border-radius: 0 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
          border: 1px solid transparent !important;
          flex-shrink: 0;
        }

        .wf-app-status-badge.is-complete {
          background: #2dce898c !important;
          border-color: #2dce89 !important;
          color: #1e293b !important;
        }

        .wf-app-status-badge.is-review {
          background: var(--yellow) !important;
          border-color: #e6c000 !important;
          color: #1e293b !important;
        }

        .wf-tool-btn {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: 1px solid #dbe3ef;
          border-radius: 0 !important;
          background: #ffffff;
          color: #475569;
          font-size: 12px;
          font-weight: 500;
          padding: 7px 10px;
          transition: all 0.18s ease;
          cursor: pointer;
          white-space: nowrap;
        }

        .wf-tool-btn:hover {
          background: #f8fafc;
          border-color: #bfdbfe;
          color: #1d4ed8;
          transform: translateY(-1px);
        }

        .wf-action-stack {
          align-items: flex-start;
          max-width: 430px;
        }

        .wf-tool-btn.is-docs,
        .wf-tool-btn.is-form,
        .wf-tool-btn.is-ach,
        .wf-tool-btn.is-insurance,
        .wf-tool-btn.is-po {
          background: #f8fafc !important;
          border-color: #dbe3ef !important;
          color: #334155 !important;
        }

        .wf-tool-btn.is-docs:hover,
        .wf-tool-btn.is-form:hover,
        .wf-tool-btn.is-ach:hover,
        .wf-tool-btn.is-insurance:hover,
        .wf-tool-btn.is-po:hover {
          background: #eff6ff !important;
          border-color: #bfdbfe !important;
          color: #1d4ed8 !important;
        }

        .wf-tool-count {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 18px;
          height: 18px;
          padding: 0 5px;
          border-radius: 0;
          background: #dc2626;
          color: #ffffff;
          font-size: 10px;
          font-weight: 600;
          line-height: 1;
        }

        .wf-tab-panel::-webkit-scrollbar,
        .wf-main-card > .card-body::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .wf-tab-panel::-webkit-scrollbar-track,
        .wf-main-card > .card-body::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 999px;
        }

        .wf-tab-panel::-webkit-scrollbar-thumb,
        .wf-main-card > .card-body::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px;
          border: 2px solid #f1f5f9;
        }

        .wf-tab-panel::-webkit-scrollbar-thumb:hover,
        .wf-main-card > .card-body::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
        }

        /* ── Modern Table Style ───────────────────────── */
        .wf-table {
          width: 100% !important;
          border-collapse: collapse !important;
          border: none !important;
        }

        .wf-table-scroll {
          width: 100% !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
          border-radius: 0 !important;
          border: 1px solid #e2e8f0 !important;
          background: #ffffff !important;
          cursor: grab;
          user-select: auto;
        }

        .wf-table-scroll.is-dragging {
          cursor: grabbing;
          user-select: none;
        }

        .wf-table-top-scroll {
          width: 100% !important;
          height: 14px;
          margin-bottom: 6px;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        .wf-table-scroll::-webkit-scrollbar,
        .wf-table-top-scroll::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .wf-table-scroll::-webkit-scrollbar-track,
        .wf-table-top-scroll::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 999px;
        }

        .wf-table-scroll::-webkit-scrollbar-thumb,
        .wf-table-top-scroll::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px;
          border: 2px solid #f1f5f9;
        }

        .wf-thead {
          background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 2 !important;
        }

        .wf-thead th {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.6px !important;
          padding: 13px 16px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important;
          white-space: nowrap !important;
        }

        .wf-table-row {
          cursor: pointer !important;
          transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
          animation: rowFadeIn 0.25s ease both !important;
        }

        .wf-table-row:hover {
          background: linear-gradient(90deg, rgba(37,99,235,0.04) 0%, rgba(37,99,235,0.015) 100%) !important;
          box-shadow: inset 3px 0 0 0 rgba(37,99,235,0.35) !important;
        }

        .wf-table-row:hover td {
          color: #1e293b !important;
        }

        .wf-table-row:active {
          transform: scaleY(0.98) !important;
        }

        .wf-table-row.selected-row {
          background: linear-gradient(90deg, rgba(37,99,235,0.07) 0%, rgba(37,99,235,0.02) 100%) !important;
          box-shadow: inset 4px 0 0 0 #2563eb !important;
        }

        .wf-table-row.selected-row:hover {
          background: linear-gradient(90deg, rgba(37,99,235,0.1) 0%, rgba(37,99,235,0.04) 100%) !important;
        }

        .wf-table td {
          padding: 13px 16px !important;
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #1e293b !important;
          border-bottom: 1px solid #f1f5f9 !important;
          vertical-align: top !important;
          transition: color 0.15s ease !important;
        }

        .wf-table-row.selected-row td {
          color: #1e293b !important;
          font-weight: 400 !important;
          border-bottom: 1px solid rgba(37, 99, 235, 0.08) !important;
        }

        .wf-table tbody tr:last-child td {
          border-bottom: none !important;
        }

        /* Modern Position Title / Entity Type styles */
        .wf-position-card {
          display: flex !important;
          flex-direction: column !important;
          gap: 6px !important;
          padding: 8px 12px !important;
          border-radius: 10px !important;
          background: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          transition: all 0.25s ease !important;
          width: 100% !important;
          min-width: 170px !important;
        }

        .wf-table-row:hover .wf-position-card {
          background: #ffffff !important;
          border-color: #cbd5e1 !important;
          box-shadow: 0 4px 12px -2px rgba(15, 23, 42, 0.04) !important;
        }

        .selected-row .wf-position-card {
          background: #ffffff !important;
          border-color: #93c5fd !important;
          box-shadow: 0 4px 12px -2px rgba(37, 99, 235, 0.08) !important;
        }

        .wf-position-title-row {
          display: flex !important;
          align-items: center !important;
          gap: 7px !important;
          font-weight: 500 !important;
          font-size: 14px !important;
          color: #1e293b !important;
          line-height: 1.35 !important;
        }

        .wf-info-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: nowrap !important;
          white-space: nowrap !important;
          gap: 4px 6px !important;
          font-size: 12px !important;
          color: #64748b !important;
          font-weight: 400 !important;
          line-height: 1.3 !important;
        }

        .wf-info-row span {
          white-space: nowrap !important;
          flex-shrink: 0 !important;
        }

        .wf-position-icon {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 22px !important;
          height: 22px !important;
          border-radius: 6px !important;
          background: #e0f2fe !important;
          color: #0369a1 !important;
          font-size: 11px !important;
          flex-shrink: 0 !important;
        }

        .wf-position-empty {
          font-size: 12px !important;
          color: #94a3b8 !important;
          font-weight: 400 !important;
          font-style: italic !important;
          display: flex !important;
          align-items: center !important;
          gap: 7px !important;
        }

        .wf-position-empty-icon {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 22px !important;
          height: 22px !important;
          border-radius: 6px !important;
          background: #f1f5f9 !important;
          color: #94a3b8 !important;
          font-size: 11px !important;
          flex-shrink: 0 !important;
        }

        .wf-entity-badge-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 6px !important;
          margin-top: 2px !important;
        }

        .wf-entity-badge {
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
          padding: 3px 8px !important;
          border-radius: 0 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          letter-spacing: 0.3px !important;
          text-transform: uppercase !important;
          border: 1px solid transparent !important;
        }

        .wf-entity-badge.basis-c2c {
          background: #eff6ff !important;
          border-color: #bfdbfe !important;
          color: #1e40af !important;
        }

        .wf-entity-badge.basis-1099 {
          background: #faf5ff !important;
          border-color: #e9d5ff !important;
          color: #6b21a8 !important;
        }

        .wf-entity-badge.basis-w2 {
          background: #ecfdf5 !important;
          border-color: #a7f3d0 !important;
          color: #065f46 !important;
        }

        .wf-rate-details-stack {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          margin-top: 5px !important;
          padding-top: 5px !important;
          border-top: 1px dashed #e2e8f0 !important;
          width: 100% !important;
        }

        .wf-rate-row {
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #64748b !important;
          line-height: 1.2 !important;
        }

        .wf-rate-label {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          color: #64748b !important;
          font-weight: 400 !important;
        }

        .wf-rate-value {
          color: #1e293b !important;
          font-weight: 500 !important;
        }

        .wf-nested-card {
          background: transparent !important;
          border: none !important;
          padding: 0 !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        /* ── Partner Card (Subcontractor / Recruiter) ─── */
        .wf-partner-card {
          display: flex !important;
          align-items: flex-start !important;
          gap: 10px !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        .wf-partner-column-stack {
          display: flex !important;
          flex-direction: column !important;
          gap: 10px !important;
          width: 100% !important;
        }

        .wf-partner-summary-card {
          padding: 12px !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 12px !important;
          background: #ffffff !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        .wf-partner-left {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          gap: 5px !important;
          flex-shrink: 0 !important;
        }

        .wf-partner-avatar,
        .wf-partner-avatar.is-recruiter,
        .wf-partner-avatar.is-inactive {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 42px !important;
          height: 42px !important;
          border-radius: 0 !important;
          background: linear-gradient(145deg, #ffffff 0%, #e9edf3 100%) !important;
          border: 1px solid #d1d5db !important;
          color: #000000 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.06em !important;
          flex: 0 0 auto !important;
          box-shadow: none !important;
          outline: none !important;
        }

        .wf-partner-avatar-id {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #f1f5f9 !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 20px !important;
          padding: 1px 8px !important;
          white-space: nowrap !important;
          letter-spacing: 0.2px !important;
        }

        .wf-partner-body {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }

        .wf-partner-name {
          font-size: 14px !important;
          color: #1e293b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.3px !important;
          line-height: 1.3 !important;
          word-break: break-word !important;
        }

        .wf-partner-name-row {
          display: flex !important;
          align-items: flex-start !important;
          gap: 6px !important;
          min-width: 0 !important;
        }

        .wf-partner-status-icon {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 18px !important;
          height: 18px !important;
          border-radius: 999px !important;
          flex: 0 0 auto !important;
          font-size: 10px !important;
          margin-top: -1px !important;
        }

        .wf-partner-status-icon.is-active {
          background: #ecfdf5 !important;
          border: 1px solid #a7f3d0 !important;
          color: #047857 !important;
        }

        .wf-partner-status-icon.is-inactive {
          background: #fef2f2 !important;
          border: 1px solid #fecaca !important;
          color: #dc2626 !important;
        }

        .wf-partner-info-row {
          display: flex !important;
          align-items: flex-start !important;
          gap: 8px !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #64748b !important;
          line-height: 1.45 !important;
          word-break: normal !important;
          overflow-wrap: anywhere !important;
        }

        .wf-partner-info-row i {
          font-size: 12px !important;
          flex-shrink: 0 !important;
          width: 13px !important;
          text-align: center !important;
          color: #94a3b8;
        }

        .wf-partner-info-row .wf-identity-meta-icon {
          width: 18px !important;
          height: 18px !important;
          margin-top: 1px !important;
        }

        .wf-partner-info-row .wf-identity-meta-icon i {
          color: inherit !important;
          font-size: 10px !important;
          width: auto !important;
        }

        .wf-partner-info-row .wf-identity-meta-text {
          flex: 1;
          min-width: 0;
          word-break: break-word;
          overflow-wrap: anywhere;
        }

        /* Modern Info Stack and Action Link styles */
        .wf-info-stack {
          display: flex !important;
          flex-direction: column !important;
          gap: 5px !important;
          width: 100% !important;
        }

        .wf-agency-card {
          display: flex !important;
          align-items: flex-start !important;
          gap: 10px !important;
          width: 100% !important;
          box-sizing: border-box !important;
          padding: 4px 0 !important;
          border: none !important;
          border-radius: 0 !important;
          background: transparent !important;
          box-shadow: none !important;
          transition: none !important;
        }

        .wf-agency-card:hover {
          border-color: transparent !important;
          box-shadow: none !important;
          transform: none !important;
        }

        .wf-entity-action-bar.wf-agency-action-bar {
          background: transparent !important;
          border: none !important;
          border-radius: 0 !important;
          padding: 4px 0 !important;
          box-shadow: none !important;
          margin-top: 6px !important;
        }

        .wf-entity-action-bar.wf-agency-action-bar:hover {
          border-color: transparent !important;
          box-shadow: none !important;
          transform: none !important;
        }

        .wf-agency-avatar {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 36px !important;
          height: 36px !important;
          border-radius: 10px !important;
          background: linear-gradient(135deg, #fef3c7 0%, #dbeafe 100%) !important;
          color: #b45309 !important;
          border: 2px solid #ffffff !important;
          outline: 1px solid #fde68a !important;
          box-shadow: 0 4px 10px rgba(180, 83, 9, 0.1) !important;
          flex: 0 0 auto !important;
          font-size: 14px !important;
        }

        .wf-agency-body {
          display: flex !important;
          flex-direction: column !important;
          gap: 6px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }

        .wf-agency-empty {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          color: #94a3b8 !important;
          font-size: 12px !important;
          font-style: italic !important;
        }

        .wf-metric-card,
        .wf-duration-summary-card {
          display: flex !important;
          align-items: flex-start !important;
          gap: 10px !important;
          width: 100% !important;
          box-sizing: border-box !important;
          padding: 0 !important;
          border: none !important;
          border-radius: 0 !important;
          background: transparent !important;
          box-shadow: none !important;
          transition: none !important;
        }

        .wf-metric-card:hover,
        .wf-duration-summary-card:hover {
          border: none !important;
          box-shadow: none !important;
          transform: none !important;
          background: transparent !important;
        }

        .wf-metric-avatar,
        .wf-metric-avatar.is-msp,
        .wf-metric-avatar.is-fee,
        .wf-metric-avatar.is-duration {
          display: none !important;
        }

        .wf-metric-body {
          display: flex !important;
          flex-direction: column !important;
          gap: 6px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }

        .wf-metric-empty {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          color: #94a3b8 !important;
          font-size: 12px !important;
          font-style: italic !important;
        }

        .wf-info-row.is-divider {
          border-top: 1px dashed #e2e8f0 !important;
          padding-top: 6px !important;
          margin-top: 2px !important;
        }

        .wf-metric-body .wf-app-actions-card,
        .wf-duration-column-stack .wf-app-actions-card {
          background: transparent !important;
          border: none !important;
          border-radius: 0 !important;
          box-shadow: none !important;
          transform: none !important;
          padding: 0 !important;
          margin-top: 6px !important;
        }

        .wf-metric-body .wf-action-stack {
          max-width: none !important;
        }

        .wf-metric-body .wf-app-actions-card:hover,
        .wf-duration-column-stack .wf-app-actions-card:hover {
          border: none !important;
          box-shadow: none !important;
          transform: none !important;
          background: transparent !important;
        }

        .wf-duration-column-stack {
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
          width: 100% !important;
        }

        .wf-info-title-link {
          font-weight: 500 !important;
          color: #2563eb !important;
          text-align: left !important;
          font-size: 14px !important;
          background: none !important;
          border: none !important;
          padding: 0 !important;
          text-transform: uppercase !important;
          transition: color 0.15s ease !important;
          cursor: pointer !important;
          outline: none !important;
          display: inline-block !important;
        }

        .wf-info-title-link:hover {
          color: #1d4ed8 !important;
          text-decoration: underline !important;
        }

        .wf-info-title-text {
          font-weight: 500 !important;
          color: #1e293b !important;
          text-align: left !important;
          font-size: 14px !important;
          text-transform: uppercase !important;
          display: inline-block !important;
          line-height: 1.35 !important;
        }

        .wf-info-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: nowrap !important;
          white-space: nowrap !important;
          gap: 4px 6px !important;
          font-size: 12px !important;
          color: #64748b !important;
          font-weight: 400 !important;
          line-height: 1.3 !important;
        }

        .wf-info-row span {
          white-space: nowrap !important;
          flex-shrink: 0 !important;
        }

        .wf-info-row i {
          font-size: 12px !important;
          width: 12px !important;
          text-align: center !important;
          color: #94a3b8 !important;
          flex-shrink: 0 !important;
        }

        .wf-info-row .wf-identity-meta-icon {
          width: 18px !important;
          height: 18px !important;
          margin-top: 0 !important;
        }

        .wf-info-row .wf-identity-meta-icon i {
          color: inherit !important;
          font-size: 10px !important;
          width: auto !important;
        }

        .wf-info-value {
          color: #1e293b !important;
          font-weight: 400 !important;
        }

        .wf-action-link {
          font-weight: 500 !important;
          color: #2563eb !important;
          font-size: 12px !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          border: none !important;
          background: none !important;
          padding: 0 !important;
          transition: color 0.15s ease !important;
          cursor: pointer !important;
          outline: none !important;
        }

        .wf-action-link:hover {
          color: #1d4ed8 !important;
          text-decoration: underline !important;
        }

        .wf-action-links-row {
          display: flex !important;
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 4px !important;
          margin-top: 6px !important;
          padding-top: 5px !important;
          border-top: 1px dashed #e2e8f0 !important;
          width: 100% !important;
        }

        /* Entity pill-card row (Subcontractor / Recruiter columns) */
        .wf-entity-pill-row {
          display: flex !important;
          align-items: center !important;
          gap: 6px !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 10px !important;
          padding: 5px 8px !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06) !important;
          width: 100% !important;
          box-sizing: border-box !important;
          min-width: 0 !important;
        }

        .wf-entity-pill-icon {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          flex-shrink: 0 !important;
          width: 26px !important;
          height: 26px !important;
          border-radius: 7px !important;
          background: #f1f5f9 !important;
          border: 1px solid #e2e8f0 !important;
          color: #64748b !important;
          font-size: 11px !important;
        }

        .wf-entity-pill-name {
          flex: 1 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          min-width: 0 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.3px !important;
        }

        .wf-entity-pill-actions {
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
          flex-shrink: 0 !important;
        }

        .wf-entity-pill-id {
          display: inline-flex !important;
          align-items: center !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          color: #475569 !important;
          background: #f1f5f9 !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 20px !important;
          padding: 1px 7px !important;
          letter-spacing: 0.2px !important;
          white-space: nowrap !important;
        }

        .wf-entity-pill-btn {
          display: inline-flex !important;
          align-items: center !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          border-radius: 0 !important;
          padding: 4px 10px !important;
          border: 1px solid !important;
          cursor: pointer !important;
          background: transparent !important;
          letter-spacing: 0.4px !important;
          transition: all 0.15s ease !important;
          white-space: nowrap !important;
          outline: none !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        .wf-entity-pill-btn.is-active {
          color: #2563eb !important;
          border-color: #93c5fd !important;
        }

        .wf-entity-pill-btn.is-active:hover {
          background: #eff6ff !important;
          border-color: #2563eb !important;
        }

        .wf-entity-pill-btn.is-inactive {
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
        }

        .wf-entity-pill-btn.is-inactive:hover {
          background: #f8fafc !important;
        }

        .wf-entity-pill-details {
          display: flex !important;
          flex-direction: column !important;
          gap: 3px !important;
          margin-top: 5px !important;
          padding-left: 2px !important;
        }

        /* Action button bar under pill card */
        .wf-entity-action-bar {
          background: #ffffff !important;
          border: 1px solid #eef2f6 !important;
          border-radius: 12px !important;
          padding: 10px 12px !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
          transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 6px !important;
          margin-top: 8px !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        .wf-entity-action-bar-row {
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: wrap !important;
          gap: 6px !important;
          justify-content: flex-start !important;
          align-items: center !important;
          width: 100% !important;
        }

        .wf-entity-action-bar .wf-tool-btn {
          width: auto !important;
          flex: 0 0 auto !important;
          justify-content: center !important;
          padding: 7px 10px !important;
          font-size: 12px !important;
          gap: 6px !important;
        }

        .wf-entity-action-bar:hover {
          border-color: #cbd5e1 !important;
          box-shadow: 0 4px 12px -2px rgba(15, 23, 42, 0.06) !important;
          transform: translateY(-1px) !important;
        }

        /* Status dot on pill header */
        .wf-entity-status-dot {
          display: inline-block !important;
          width: 8px !important;
          height: 8px !important;
          border-radius: 50% !important;
          flex-shrink: 0 !important;
        }

        .wf-entity-status-dot.is-active {
          background: #10b981 !important;
          box-shadow: 0 0 0 2px #d1fae5 !important;
        }

        .wf-entity-status-dot.is-inactive {
          background: #ef4444 !important;
          box-shadow: 0 0 0 2px #fee2e2 !important;
        }

        .wf-status-indicator {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 15px !important;
          height: 15px !important;
          border-radius: 50% !important;
          flex-shrink: 0 !important;
          line-height: 1 !important;
        }

        .wf-status-indicator i {
          font-size: 8px !important;
          margin: 0 !important;
          padding: 0 !important;
          line-height: 1 !important;
        }

        .wf-status-indicator.is-active {
          background: #ecfdf5 !important;
          border: 1px solid #a7f3d0 !important;
          color: #059669 !important;
        }

        .wf-status-indicator.is-inactive {
          background: #fef2f2 !important;
          border: 1px solid #fca5a5 !important;
          color: #b91c1c !important;
        }

        .wf-activation-stack,
        .wf-status-stack {
          display: flex !important;
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 6px !important;
          min-width: 0 !important;
        }

        .wf-status-pill {
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
          width: max-content !important;
          border-radius: 0 !important;
          border: 1px solid #dbe3ef !important;
          background: #f8fafc !important;
          color: #64748b !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          line-height: 1 !important;
          padding: 5px 8px !important;
          text-transform: uppercase !important;
          white-space: nowrap !important;
        }

        .wf-status-pill.is-complete {
          background: #ecfdf5 !important;
          border-color: #bbf7d0 !important;
          color: #047857 !important;
        }

        .wf-status-pill.is-danger {
          background: #fef2f2 !important;
          border-color: #fecaca !important;
          color: #dc2626 !important;
        }

        .wf-status-pill.is-muted {
          background: #f8fafc !important;
          border-color: #e2e8f0 !important;
          color: #64748b !important;
        }

        .wf-link-action {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          width: max-content !important;
          border: 1px solid #dbe3ef !important;
          border-radius: 0 !important;
          background: #ffffff !important;
          color: #334155 !important;
          font-size: 11px !important;
          font-weight: 500 !important;
          padding: 5px 9px !important;
          transition: all 0.18s ease !important;
          cursor: pointer !important;
          white-space: nowrap !important;
        }

        .wf-link-action:hover {
          background: #f8fafc !important;
          border-color: #bfdbfe !important;
          color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
        }

        /* ── Form Header ── */
        .as-form-header {
          display: flex !important;
          align-items: flex-start !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 18px !important;
          padding: 20px 24px !important;
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
          border-bottom: 1px solid rgba(226, 232, 240, 0.9) !important;
          position: relative !important;
          overflow: hidden !important;
          border-radius: 8px 8px 0 0 !important;
          margin: -16px -16px 25px -16px !important;
          width: calc(100% + 32px) !important;
        }
        .as-form-header-left {
          display: flex !important;
          align-items: flex-start !important;
          gap: 14px !important;
          min-width: 260px !important;
          flex: 1 1 360px !important;
        }
        .as-form-header-right {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          flex-wrap: wrap !important;
          justify-content: flex-end !important;
          margin-left: auto !important;
          position: relative !important;
          z-index: 1 !important;
          flex-shrink: 0 !important;
        }
        .as-header-back-btn {
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 7px 14px !important;
          color: #1e293b !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          outline: none !important;
          height: auto !important;
          min-height: 32px !important;
        }
        .as-header-back-btn:hover {
          background: #f1f5f9 !important;
          border-color: #94a3b8 !important;
          color: #0f172a !important;
          transform: translateY(-1px) !important;
        }
        .as-form-header-icon {
          width: 44px !important;
          height: 44px !important;
          border-radius: 12px !important;
          background: linear-gradient(135deg, #2563eb 0%, #0284c7 100%) !important;
          border: 1px solid rgba(37, 99, 235, 0.18) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #ffffff !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
          box-shadow: 0 12px 22px rgba(15, 23, 42, 0.16) !important;
        }
        .as-form-header-text {
          position: relative !important;
          z-index: 1 !important;
        }
        .as-form-header-title {
          color: #1e293b !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          margin: 0 !important;
          line-height: 1.2 !important;
        }
        .as-form-header-sub {
          color: #64748b !important;
          font-size: 14px !important;
          margin-top: 6px !important;
          font-weight: 400 !important;
          max-width: 620px !important;
        }
        .as-form-header-meta {
          display: flex !important;
          align-items: center !important;
          gap: 7px !important;
          flex-wrap: wrap !important;
          margin-top: 10px !important;
        }
        .as-meta-pill {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 4px 12px !important;
          border-radius: 99px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          color: #64748b !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          height: auto !important;
          line-height: 1.5 !important;
        }
        .as-meta-pill i { font-size: 12px !important; }
        .as-meta-pill.meta-id i { color: #1d4ed8 !important; }
        .as-meta-pill.meta-person i { color: #047857 !important; }
        .as-meta-pill.meta-email i { color: #0369a1 !important; }
        .as-meta-pill.meta-entity i { color: #6d28d9 !important; }
        .as-meta-pill.meta-benefits i { color: #b45309 !important; }

        /* Time Log & Invoice Column Styling */
        .wf-timelog-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          background: #ffffff !important;
          color: #0f172a !important;
          border: 1px solid #cbd5e1 !important;
          outline: none !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          padding: 6px 14px !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          white-space: nowrap !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
        }

        .wf-timelog-action-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #0f172a !important;
          box-shadow: 0 2px 4px rgba(15, 23, 42, 0.08) !important;
          transform: translateY(-1px) !important;
        }

        .wf-timelog-action-btn:hover i {
          transform: translateX(2px) !important;
        }
      `}</style>

      <div className="col-md-12">
        <div className="card mb-4 shadow-none wf-main-card list-subcontractor-page list-candidate-page">
          {isTableLoading && <div className="wf-loading-bar" />}

          <div className="wf-card-header-bar">
            <div className="wf-header-left">
              <PageSizeOptions
                pageSize={pageSize}
                onChange={handlePageSizeChanged}
              />
              <span className="wf-stats-chip">
                <i className="fa fa-users" aria-hidden="true" />
                <span>{rowsCount} Candidates</span>
              </span>
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className="btn-search-trigger"
                onClick={handleSearchShowHide}
              >
                <i
                  className={`fa ${filterShowHide ? "fa-times" : "fa-filter"}`}
                  aria-hidden="true"
                />{" "}
                {filterShowHide ? "Close Filters" : "Filters"}
              </button>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                title="Reload candidates"
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
            </div>
          </div>

          {filterShowHide && (
            <div className="px-3 mt-2">
              <div className="search-panel-collapse">
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter Candidates
                  </span>
                  <span className="sp-header-badge">
                    <i className="fa fa-filter" /> Advanced Search
                  </span>
                </div>

                <div className="sp-body">
                  <div className="row">
                    <div className="col-md-4 form-group mb-3">
                      <label htmlFor="canId" className="wf-control-label">
                        <i className="fa fa-user" /> Candidate Name
                      </label>
                      <SearchableSelect
                        id="canId"
                        name="canId"
                        placeholder="Select Candidate"
                        value={canId}
                        onChange={(value) => setCanId(value || "0")}
                        options={filterCandidateList.map((y) => ({
                          value: y.maxloans,
                          label: `${y.performername} ${y.lastName} - ${y.maxloans}`,
                        }))}
                      />
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      <label htmlFor="canEmail" className="wf-control-label">
                        <i className="fa fa-envelope" /> Email
                      </label>
                      <div className="wf-input-wrap">
                        <i className="fa fa-envelope wf-input-icon" aria-hidden="true" />
                        <input
                          type="text"
                          name="canEmail"
                          id="canEmail"
                          aria-label="Email Input"
                          className="form-control wf-input"
                          placeholder="Email"
                          onChange={({ currentTarget }) => setCanEmail(currentTarget.value)}
                          value={canEmail}
                          onKeyDown={(e) => e.key === "Enter" && handleCandidateFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      <label htmlFor="canEntity" className="wf-control-label">
                        <i className="fa fa-briefcase" /> Entity Type
                      </label>
                      <SearchableSelect
                        id="canEntity"
                        name="canEntity"
                        placeholder="Select Entity Type"
                        isDisabled={candidateType !== ""}
                        value={canEntity}
                        onChange={setCanEntityFunc}
                        options={candidateEntity.map((item) => ({
                          value: item.name,
                          label: item.name,
                        }))}
                      />
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      <label htmlFor="canSubcontractor" className="wf-control-label">
                        <i className="fa fa-building" /> Subcontractor
                      </label>
                      <SearchableSelect
                        id="canSubcontractor"
                        name="canSubcontractor"
                        placeholder="Select Subcontractor"
                        value={canSubcontractor}
                        onChange={setCanSubcontractor}
                        options={(filterSubcontractorList || []).map((item) => ({
                          value: item.fuid,
                          label: `${item.label} - ${item.fuid}`,
                        }))}
                      />
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      <label htmlFor="canRecruiter" className="wf-control-label">
                        <i className="fa fa-users" /> Recruiter
                      </label>
                      <SearchableSelect
                        id="canRecruiter"
                        name="canRecruiter"
                        placeholder="Select Recruiter"
                        value={canRecruiter}
                        onChange={setCanRecruiter}
                        options={filterRecruiterList.map((item) => ({
                          value: item.fuid,
                          label: `${item.label} - ${item.fuid}`,
                        }))}
                      />
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      <label htmlFor="canAgency" className="wf-control-label">
                        <i className="fa fa-handshake-o" /> Agency
                      </label>
                      <SearchableSelect
                        id="canAgency"
                        name="canAgency"
                        placeholder="Select Agency"
                        value={canAgency}
                        onChange={setCanAgency}
                        options={filterAgencyList.map((item) => ({
                          value: item.title,
                          label: item.title,
                        }))}
                      />
                    </div>
                  </div>
                </div>

                <div className="sp-footer">
                  <button
                    className="btn-action-search btn-danger-search"
                    onClick={() => handleFilterCancel("close")}
                  >
                    <i className="fa fa-times" aria-hidden="true" /> Clear &amp; Close
                  </button>
                  <button
                    className="btn-action-search"
                    onClick={() => handleFilterCancel("refresh")}
                  >
                    <i className="fa fa-refresh" aria-hidden="true" /> Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={() => handleCandidateFilter()}
                    disabled={
                      (!canId || canId === "0" || canId === "") &&
                      !canEmail?.trim() &&
                      !canEntity &&
                      !canSubcontractor &&
                      !canRecruiter &&
                      !canAgency
                    }
                  >
                    <i className="fa fa-search" aria-hidden="true" /> Apply Filters
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="card-body px-3 pt-2 pb-3 wf-tabs-container">
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedTabKey === "home" ? " active" : ""}`}
                onClick={() => {
                  setSelectedTabKey("home");
                  setSelectedFormKey(-1);
                  setSelectedKey(-1);
                  setViewFormType("");
                }}
              >
                <i className="fa fa-list-alt" />
                Candidates
                <span className="wf-tab-badge">
                  {candidates.length > 0 ? rowsCount : "—"}
                </span>
              </button>

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTabKey === "addEditCandidate" ? " active" : ""}`}
                  onClick={() => setSelectedTabKey("addEditCandidate")}
                >
                  <i
                    className={`fa ${selectedCandidateId === 0 ? "fa-plus-circle" : "fa-edit"}`}
                  />
                  {selectedCandidateId === 0 ? "Add" : "Edit"} Candidate & Entities
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTabKey === "contracts" ? " active" : ""}${selectedCandidateId === 0 ? " tab-locked" : ""}`}
                  onClick={() => setSelectedTabKey("contracts")}
                >
                  <i className="fa fa-file-text-o" />
                  {getDynamicTabTitle(docUploadType, selectedCandidateId)}
                  {selectedCandidateId > 0 ? (
                    <span className="wf-tab-badge">
                      {docsCount}
                    </span>
                  ) : null}
                </button>
              )}

              {type === "application" &&
                (selectedCandidateId === 0 || ["W2 Basis", "1099 Basis"].includes(
                  getFieldData(selectedObj?.performerData, "candidateonboardingform", "CandidateEntity")
                )) && (
                  <button
                    className={`wf-tab-btn${selectedTabKey === "ach" ? " active" : ""}${selectedCandidateId === 0 ? " tab-locked" : ""}`}
                    onClick={() => setSelectedTabKey("ach")}
                  >
                    <i className="fa fa-bank" />
                    ACH
                    {selectedCandidateId > 0 ? (
                      <span className="wf-tab-badge">
                        {selectedApp?.achRequest || 0}
                      </span>
                    ) : null}
                  </button>
                )}

              {type === "application" &&
                (selectedCandidateId === 0 || (selectedObj?.subcontractor?.fuid > 0 || selectedObj?.recruiter?.fuid > 0)) && (
                  <button
                    className={`wf-tab-btn${selectedTabKey === "purchaseOrder" ? " active" : ""}${selectedCandidateId === 0 ? " tab-locked" : ""}`}
                    onClick={() => setSelectedTabKey("purchaseOrder")}
                  >
                    <i className="fa fa-shopping-cart" />
                    Purchase Order
                    {selectedCandidateId > 0 ? (
                      <span className="wf-tab-badge">
                        {purchaseOrdersSelector?.filter(x =>
                          (x.type === "subcontractor" && selectedObj?.subcontractor?.fuid > 0) ||
                          (x.type === "recruiter" && selectedObj?.recruiter?.fuid > 0)
                        ).length || 0}
                      </span>
                    ) : null}
                  </button>
                )}

              {type === "application" && viewFormType && (
                <button
                  className={`wf-tab-btn${selectedTabKey === "onboardingForm" ? " active" : ""}`}
                  onClick={() => setSelectedTabKey("onboardingForm")}
                >
                  <i className="fa fa-list-alt" />
                  {viewFormTabTitle || getOnboardingFormTitle(viewFormType)}
                </button>
              )}

              {type === "partner" && (
                <button
                  className={`wf-tab-btn${selectedTabKey === "status" ? " active" : ""}${selectedCandidateId === 0 ? " tab-locked" : ""}`}
                  onClick={() => setSelectedTabKey("status")}
                >
                  <i className="fa fa-toggle-on" />
                  Activate/Deactivate
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTabKey === "duration" ? " active" : ""}${selectedCandidateId === 0 ? " tab-locked" : ""}`}
                  onClick={() => {
                    setSelectedTabKey("duration");
                    setEditDurType("duration");
                  }}
                >
                  <i className="fa fa-calendar" />
                  Duration
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTabKey === "rate" ? " active" : ""}${selectedCandidateId === 0 ? " tab-locked" : ""}`}
                  onClick={() => {
                    setSelectedTabKey("rate");
                    setEditDurType("rate");
                  }}
                >
                  <i className="fa fa-money" />
                  Rate
                </button>
              )}
            </div>

            <div className="wf-tab-panel">
              {selectedTabKey === "home" && (
                <div className="mt-3">
                  {type !== "timelog" && type !== "invoice" && selectedCandidateId > 0 && selectedObj && (
                    <div
                      className="wf-assign-card"
                      style={{ marginTop: 8, marginBottom: 14 }}
                    >
                      <div className="wf-assign-info">
                        <div className="wf-assign-avatar">
                          {getInitial(`${selectedObj.performername || ""} ${selectedObj.lastName || ""}`).substring(0, 2)}
                        </div>
                        <div className="wf-assign-meta">
                          <strong>
                            {selectedObj.performername} {selectedObj.lastName}
                          </strong>
                          <span>
                            <i className="fa fa-hashtag" style={{ marginRight: 4 }} />
                            ID: #{selectedObj.performerid}
                            {selectedObj.maxloans && (
                              <>
                                &nbsp;&bull;&nbsp;
                                IPCS: #{selectedObj.maxloans}
                              </>
                            )}
                            {selectedObj.performeremail && (
                              <>
                                &nbsp;&bull;&nbsp;
                                <i className="fa fa-envelope-o" style={{ marginRight: 4 }} />
                                {selectedObj.performeremail}
                              </>
                            )}
                            {selectedObj.contactNo && (
                              <>
                                &nbsp;&bull;&nbsp;
                                <i className="fa fa-phone" style={{ marginRight: 4 }} />
                                {getFormatedNumber(selectedObj.contactNo)}
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="wf-assign-actions">
                        {type === "partner" && (
                          <button
                            className="btn-action-search"
                            onClick={() => setSelectedTabKey("status")}
                          >
                            Status
                          </button>
                        )}
                        {type === "application" && (
                          <>
                            <button
                              className="btn-action-search"
                              onClick={() => setSelectedTabKey("addEditCandidate")}
                            >
                              Edit Candidate
                            </button>
                            <button
                              className="btn-action-search"
                              onClick={() => {
                                if (selectedApp) {
                                  handleWorkflowPanelOpen("contracts", selectedObj, selectedApp, "Candidate");
                                }
                              }}
                              disabled={!selectedApp}
                            >
                              Documents
                              {selectedApp && docsCount > 0 && (
                                <span className="wf-tool-count">{docsCount}</span>
                              )}
                            </button>
                            {["W2 Basis", "1099 Basis"].includes(
                              getFieldData(selectedObj?.performerData, "candidateonboardingform", "CandidateEntity")
                            ) && (
                                <button
                                  className="btn-action-search"
                                  onClick={() => {
                                    if (selectedApp) {
                                      handleWorkflowPanelOpen("ach", selectedObj, selectedApp);
                                    }
                                  }}
                                  disabled={!selectedApp}
                                >
                                  ACH
                                  {selectedApp?.achRequest > 0 && (
                                    <span className="wf-tool-count">{selectedApp.achRequest}</span>
                                  )}
                                </button>
                              )}
                            {(selectedObj?.subcontractor?.fuid > 0 || selectedObj?.recruiter?.fuid > 0) && (
                              <button
                                className="btn-action-search"
                                onClick={() => {
                                  if (selectedApp) {
                                    handleWorkflowPanelOpen(
                                      "purchaseOrder",
                                      selectedObj,
                                      selectedApp,
                                      selectedObj?.subcontractor?.fuid > 0 ? "Subcontractor" : "Recruiter"
                                    );
                                  }
                                }}
                                disabled={!selectedApp}
                              >
                                Purchase Order
                                {selectedApp && purchaseOrdersSelector?.filter(x =>
                                  (x.type === "subcontractor" && selectedObj?.subcontractor?.fuid > 0) ||
                                  (x.type === "recruiter" && selectedObj?.recruiter?.fuid > 0)
                                ).length > 0 && (
                                    <span className="wf-tool-count">
                                      {purchaseOrdersSelector.filter(x =>
                                        (x.type === "subcontractor" && selectedObj?.subcontractor?.fuid > 0) ||
                                        (x.type === "recruiter" && selectedObj?.recruiter?.fuid > 0)
                                      ).length}
                                    </span>
                                  )}
                              </button>
                            )}
                            <button
                              className="btn-action-search"
                              onClick={() => handleDurationAndRateShowHide(selectedObj, "duration", -1)}
                            >
                              Duration
                            </button>
                            <button
                              className="btn-action-search"
                              onClick={() => handleDurationAndRateShowHide(selectedObj, "rate", -1)}
                            >
                              Rates
                            </button>
                          </>
                        )}
                        <button
                          className="btn-action-search btn-danger-search"
                          onClick={handleResetSelection}
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  )}

                  {hasTableHorizontalScroll && (
                    <div
                      className="wf-table-top-scroll"
                      ref={topTableScrollRef}
                      onScroll={handleTopTableScroll}
                      aria-hidden="true"
                    >
                      <div style={{ width: tableScrollWidth, height: 1 }} />
                    </div>
                  )}

                  <div
                    className="table-responsive wf-table-scroll"
                    ref={tableScrollRef}
                    onScroll={handleTableScroll}
                    onMouseDown={handleTableMouseDown}
                    onMouseMove={handleTableMouseMove}
                    onMouseUp={handleTableMouseUp}
                    onMouseLeave={handleTableMouseUp}
                    onClickCapture={handleTableClickCapture}
                  >
                    {/* <button className="btn btn-sm btn-link" onClick={handleResetSelection}>Reset Selection</button> */}
                    <table className="wf-table wf-table-modern table-striped mb-2">
                      <thead className="wf-thead">
                        <tr>
                          <th style={{ minWidth: "220px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <span>Candidate / ID # / IPCS ID</span>
                              {type !== "timelog" && type !== "invoice" && selectedCandidateId > 0 && (
                                <button
                                  type="button"
                                  className="wf-reset-selection"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleResetSelection();
                                  }}
                                  title="Clear selection"
                                  style={{ margin: 0, padding: "2px 6px", height: "20px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                                >
                                  <i className="fa fa-refresh" style={{ fontSize: "10px" }} />
                                </button>
                              )}
                            </div>
                          </th>
                          <th>
                            Position & Entity Type
                          </th>
                          {type === "timelog" || type === "invoice" ? <>
                            {type === "timelog" && (
                              <th>
                                Time Log
                              </th>
                            )}
                            {type === "invoice" && (
                              <th>
                                Invoices & Payments
                              </th>
                            )}
                          </> : ""}

                          {type !== "timelog" && type !== "invoice" ? (
                            <>
                              <th>Onboarding</th>
                              {(type === "partner" || type === "application") && <th>Status</th>}
                              {type !== "partner" && (
                                <>
                                  <th>Agency/Client</th>
                                  <th>Subcontractor</th>
                                  <th>Recruiter</th>
                                  <th style={{ minWidth: "180px" }}>MSP</th>
                                  <th>Tech/Other Fee</th>
                                  <th>Duration & Rate</th>
                                </>
                              )}
                            </>
                          ) : null}
                          {type !== "timelog" && type !== "invoice" && type !== "application" && (
                            <th>Activation</th>
                          )}

                        </tr>
                      </thead>
                      <tbody className="bg-white">
                        {isTableLoading ? (
                          Array.from({ length: pageSize > 5 ? 5 : pageSize }).map((_, i) => (
                            <tr key={`candidate-skel-${i}`} className="skeleton-row">
                              <td>
                                <div className="skeleton-identity">
                                  <span className="skeleton-cell sk-avatar" style={{ animationDelay: `${i * 0.04}s` }} />
                                  <div className="skeleton-stack">
                                    <span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.05}s` }} />
                                    <span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.07}s` }} />
                                    <span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.06}s` }} />
                                  </div>
                                </div>
                              </td>
                              <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                              {(type === "timelog" || type === "invoice") && (
                                <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                              )}
                              {type !== "timelog" && type !== "invoice" ? (
                                <>
                                  <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.04}s` }} /></td>
                                  <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                  {type !== "partner" && (
                                    <>
                                      <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                                      <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                      <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                      <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.04}s` }} /></td>
                                      <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                      <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                                    </>
                                  )}
                                </>
                              ) : null}
                              {type !== "timelog" && type !== "invoice" && type !== "application" && (
                                <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                              )}
                            </tr>
                          ))
                        ) : candidates.length === 0 ? (
                          <tr>
                            <td colSpan={candidateTableColSpan} style={{ padding: 0 }}>
                              <div className="wf-empty-state">
                                <div className="wf-empty-icon">
                                  <i className={dataType === "filter" ? "fa fa-search" : "fa fa-list-alt"} />
                                </div>
                                <p className="wf-empty-title">
                                  {dataType === "filter" ? "No Matching Candidates" : "No Candidates Found"}
                                </p>
                                <p className="wf-empty-desc">
                                  {dataType === "filter"
                                    ? "Try adjusting or resetting the filters to see candidates."
                                    : "There are no candidates available yet. Once created, they will appear here."}
                                </p>
                                {dataType === "filter" && (
                                  <button
                                    className="btn-action-search"
                                    onClick={() => handleFilterCancel("refresh")}
                                    style={{ marginTop: 4 }}
                                  >
                                    <i className="fa fa-refresh" aria-hidden="true" /> Reset Filters
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ) : (
                          candidates.map((item, key) => (
                            <React.Fragment key={item.performerid || key}>
                              <tr
                                className={`wf-table-row ${selectedCandidateId === item.performerid ? "selected-row" : ""} ${(selectedKey !== key && selectedKey !== -1) || (SelectedFormKey !== key && SelectedFormKey !== -1) ? "d-none" : ""}`}
                                onClick={() => {
                                  if (type !== "timelog" && type !== "invoice") {
                                    handleSelectCandidate(item);
                                  }
                                }}
                                style={{ animationDelay: `${key * 0.03}s` }}
                                title={type !== "timelog" && type !== "invoice" ? (selectedCandidateId === item.performerid ? `Click to deselect: ${item.performername} ${item.lastName}` : `Click to select: ${item.performername} ${item.lastName}`) : ""}
                              >

                                <td style={{ minWidth: "220px" }}>
                                  <div className="wf-identity-cell">
                                    <div className="wf-avatar-stack" style={{ position: "relative" }}>
                                      <CandidateAvatar candidate={item} />
                                      {selectedCandidateId === item.performerid && (
                                        <div className="wf-avatar-check-badge">
                                          <i className="fa fa-check" />
                                        </div>
                                      )}
                                      <span className="wf-inline-id">
                                        #{item.performerid}
                                      </span>
                                    </div>
                                    <div className="wf-identity-copy">
                                      <div className="wf-identity-heading">
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleViewcandidateForm("Candidate", key, item);
                                          }}
                                          className="btn p-0 btn-link btn-sm text-uppercase wf-identity-title" style={{ display: "inline", padding: 0, border: "none", verticalAlign: "baseline", background: "transparent", textAlign: "left", fontWeight: 600, boxShadow: "none" }}
                                        >
                                          {item.performername} {item.lastName}
                                        </button>
                                      </div>

                                      {item.maxloans && (
                                        <div className="wf-identity-meta-row" style={{ margin: "2px 0 4px" }}>
                                          <span className="wf-inline-id" style={{ background: "#ecfdf5", borderColor: "#bbf7d0", color: "#047857", fontSize: "10px", fontWeight: "600" }}>
                                            IPCS: #{item.maxloans}
                                          </span>
                                        </div>
                                      )}

                                      {item.performeremail && (
                                        <div className="wf-identity-meta-row">
                                          <div className="wf-identity-meta-icon wf-icon-email">
                                            <i className="fa fa-envelope-o" />
                                          </div>
                                          <span className="wf-identity-meta-text">
                                            {item.performeremail}
                                          </span>
                                        </div>
                                      )}

                                      {item.contactNo && (
                                        <div className="wf-identity-meta-row">
                                          <div className="wf-identity-meta-icon wf-icon-phone">
                                            <i className="fa fa-phone" />
                                          </div>
                                          <span className="wf-identity-meta-text">
                                            {getFormatedNumber(item.contactNo)}
                                          </span>
                                        </div>
                                      )}

                                      {item.addedDateTime && (
                                        <div className="wf-identity-meta-row">
                                          <div className="wf-identity-meta-icon wf-icon-calendar">
                                            <i className="fa fa-calendar-o" />
                                          </div>
                                          <span className="wf-identity-meta-text">
                                            <Moment format="MMM Do YYYY, h:mm a">
                                              {item.addedDateTime}
                                            </Moment>
                                          </span>
                                        </div>
                                      )}

                                      {(getFieldData(item?.performerData, "candidateonboardingform", "Current_Address_Line1") ||
                                        getFieldData(item?.performerData, "candidateonboardingform", "Current_City") ||
                                        getFieldData(item?.performerData, "candidateonboardingform", "Current_State") ||
                                        getFieldData(item?.performerData, "candidateonboardingform", "Current_Zip_Code")) && (
                                          <div className="wf-identity-meta-row">
                                            <div className="wf-identity-meta-icon wf-icon-address">
                                              <i className="fa fa-map-marker" />
                                            </div>
                                            <span className="wf-identity-meta-text wf-identity-address-text">
                                              {getAddressLines(item).map(
                                                (line, lineIndex) => (
                                                  <span key={lineIndex}>
                                                    {line}
                                                  </span>
                                                ),
                                              )}
                                            </span>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </td>

                                <td className="pb-0" style={{ minWidth: "190px" }}>
                                  <div className="wf-position-card">
                                    {getFieldData(
                                      item.performerData,
                                      "projectengagement",
                                      "PositionTitle"
                                    ) ? (
                                      <div className="wf-position-title-row">
                                        <div className="wf-position-icon">
                                          <i className="fa fa-briefcase" />
                                        </div>
                                        <span title={getFieldData(item.performerData, "projectengagement", "PositionTitle")}>
                                          {getFieldData(item.performerData, "projectengagement", "PositionTitle")}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="wf-position-empty">
                                        <div className="wf-position-empty-icon">
                                          <i className="fa fa-briefcase" />
                                        </div>
                                        <span>No Position Title</span>
                                      </div>
                                    )}

                                    <div className="wf-entity-badge-row">
                                      {getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "CandidateEntity"
                                      ) ? (
                                        <>
                                          {getFieldData(item.performerData, "candidateonboardingform", "CandidateEntity") === "C2C Basis" && (
                                            <span className="wf-entity-badge basis-c2c">
                                              <i className="fa fa-building-o" /> C2C
                                            </span>
                                          )}
                                          {getFieldData(item.performerData, "candidateonboardingform", "CandidateEntity") === "1099 Basis" && (
                                            <span className="wf-entity-badge basis-1099">
                                              <i className="fa fa-handshake-o" /> 1099
                                            </span>
                                          )}
                                          {getFieldData(item.performerData, "candidateonboardingform", "CandidateEntity") === "W2 Basis" && (
                                            <span className="wf-entity-badge basis-w2">
                                              <i className="fa fa-user-circle-o" /> W2 {getFieldData(item.performerData, "candidateonboardingform", "w9_Type") && `(${getFieldData(item.performerData, "candidateonboardingform", "w9_Type")})`}
                                            </span>
                                          )}
                                        </>
                                      ) : (
                                        <span style={{ color: "#94a3b8", fontSize: "12px", fontWeight: 400, fontStyle: "italic" }}>No Entity Type</span>
                                      )}
                                    </div>

                                    {type !== "partner" && (shouldShowCandidateRate(item) || getFieldData(item.performerData, "candidateonboardingform", "Per_Diem_Rate")) ? (
                                      <div className="wf-rate-details-stack">
                                        {shouldShowCandidateRate(item) ? (
                                          <div className="wf-rate-row">
                                            <span className="wf-rate-label">
                                              <span className="wf-identity-meta-icon wf-icon-money">
                                                <i className="fa fa-money" />
                                              </span>
                                              Rate
                                            </span>
                                            <span className="wf-rate-value">
                                              <RateEncryptDecrypt rateData={item?.rates?.candidateRate} />
                                            </span>
                                          </div>
                                        ) : null}
                                        {getFieldData(item.performerData, "candidateonboardingform", "Per_Diem_Rate") ? (
                                          <div className="wf-rate-row">
                                            <span className="wf-rate-label">
                                              <i className="fa fa-cutlery" /> Per Diem
                                            </span>
                                            <span className="wf-rate-value">
                                              <RateEncryptDecrypt rateData={getFieldData(item.performerData, "candidateonboardingform", "Per_Diem_Rate")} endSymbol="/Day" />
                                            </span>
                                          </div>
                                        ) : null}
                                      </div>
                                    ) : null}
                                  </div>
                                </td>

                                {type === "timelog" || type === "invoice" ? (
                                  <td className="pb-0" style={{ verticalAlign: "middle" }}>
                                    {type === "timelog" ? (
                                      <button
                                        type="button"
                                        className="wf-timelog-action-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleViewCandidateDetails(item, type);
                                        }}
                                        title={`Manage time logs for ${item.performername}`}
                                      >
                                        Manage{" "}
                                        <i
                                          className="fa fa-chevron-right"
                                          style={{
                                            fontSize: "9px",
                                            transition: "transform 0.15s ease",
                                          }}
                                        />
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        className="wf-timelog-action-btn is-invoice-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleViewCandidateDetails(item, type);
                                        }}
                                        title={`Manage invoices for ${item.performername}`}
                                      >
                                        Pay Hub{" "}
                                        <i
                                          className="fa fa-chevron-right"
                                          style={{
                                            fontSize: "9px",
                                            transition: "transform 0.15s ease",
                                          }}
                                        />
                                      </button>
                                    )}
                                  </td>
                                ) : (
                                  ""
                                )}





                                {type !== "timelog" && type !== "invoice" && (
                                  <React.Fragment>
                                    <td className="pb-0" style={{ minWidth: "220px" }}>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "8px",
                                          width: "100%",
                                          boxSizing: "border-box",
                                        }}
                                      >
                                        {item.applications?.length > 0 ? (
                                          item.applications.map((app) => (
                                            <React.Fragment key={app.applicationId}>
                                              {/* Application Name Card */}
                                              {type === "partner" && (
                                                <div
                                                  className="wf-app-name-card"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleViewApplication(item, app);
                                                  }}
                                                  title="Open application review"
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <div
                                                    className="wf-app-header-left"
                                                    style={{
                                                      flex: 1,
                                                      minWidth: 0,
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <div className="wf-app-icon-wrapper" style={{ marginRight: "6px" }}>
                                                    </div>
                                                    <span
                                                      className="wf-app-title-text"
                                                      style={{
                                                        flex: 1,
                                                        minWidth: 0,
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      {app.applicationType || "Application"}
                                                    </span>
                                                    <span
                                                      className="wf-app-id-text"
                                                      style={{
                                                        flexShrink: 0,
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      #{app.applicationId}
                                                    </span>
                                                  </div>
                                                </div>
                                              )}

                                              {/* Action Buttons */}
                                              {type === "application" && (
                                                <div className="wf-app-actions-card">
                                                  <div
                                                    className="wf-action-stack"
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      gap: "6px",
                                                    }}
                                                  >
                                                    {/* Row 1: Application button */}
                                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                                      <button
                                                        type="button"
                                                        className="wf-tool-btn is-app"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          handleViewApplication(item, app);
                                                        }}
                                                        title="Open application review"
                                                      >
                                                        {app.applicationType || "Candidate Application"}
                                                        <span className="wf-tool-count is-id">
                                                          #{app.applicationId}
                                                        </span>
                                                      </button>
                                                    </div>

                                                    {/* Row 2: Remaining action buttons */}
                                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                                      <button
                                                        type="button"
                                                        className="wf-tool-btn is-form"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          handleViewcandidateForm("Candidate", key, item);
                                                        }}
                                                        title="Candidate form"
                                                      >
                                                        Onboarding Form
                                                      </button>

                                                      <button
                                                        type="button"
                                                        className="wf-tool-btn is-docs"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          handleWorkflowPanelOpen("contracts", item, app, "Candidate");
                                                        }}
                                                        title="Contract Documents"
                                                      >
                                                        Documents
                                                        {selectedCandidateId === item.performerid && (
                                                          <span className="wf-tool-count">
                                                            {docsCount}
                                                          </span>
                                                        )}
                                                      </button>

                                                      {["W2 Basis", "1099 Basis"].includes(
                                                        getFieldData(item.performerData, "candidateonboardingform", "CandidateEntity")
                                                      ) && (
                                                          <button
                                                            type="button"
                                                            className="wf-tool-btn is-ach"
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              handleWorkflowPanelOpen("ach", item, app);
                                                            }}
                                                            title="ACH Information"
                                                          >
                                                            ACH
                                                            {app?.achRequest > 0 && (
                                                              <span className="wf-tool-count">
                                                                {app.achRequest}
                                                              </span>
                                                            )}
                                                          </button>
                                                        )}
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </React.Fragment>
                                          ))
                                        ) : (
                                          <span className="wf-muted-text">No applications</span>
                                        )}
                                      </div>
                                    </td>
                                    {(type === "partner" || type === "application") && (
                                      <td>
                                        <div className="wf-status-stack">
                                          {item.applications?.length > 0 ? (
                                            item.applications.map((app) => (
                                              <span
                                                key={`candidate-ob-status-${app.applicationId}`}
                                                className={`wf-app-status-badge ${app.appSubmitted ? "is-complete" : "is-review"}`}
                                                style={{ minWidth: "78px", padding: "0 10px", whiteSpace: "nowrap", justifyContent: "center" }}
                                              >
                                                {app.appSubmitted ? "Complete" : "Review"}
                                              </span>
                                            ))
                                          ) : (
                                            <span
                                              className={`wf-status-pill ${item.enrollmentStatus ? "is-complete" : "is-pending"}`}
                                            >
                                              <i
                                                className={`fa ${item.enrollmentStatus ? "fa-check-circle" : "fa-clock-o"}`}
                                              />
                                              {item.enrollmentStatus
                                                ? "Complete"
                                                : "Pending"}
                                            </span>
                                          )}
                                        </div>
                                        <div
                                          className="wf-row-actions mt-2"
                                          onClick={(event) =>
                                            event.stopPropagation()
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="wf-link-action"
                                            onClick={() =>
                                              handleRemainder(
                                                item.performerid || item.contact1?.performerid,
                                              )
                                            }
                                          >
                                            <i className="fa fa-bell-o" />
                                            Reminder
                                          </button>
                                          <button
                                            type="button"
                                            className="wf-link-action"
                                            title="View message"
                                            onClick={handleRemainderMessage}
                                          >
                                            <i className="fa fa-envelope-o" />
                                            {item.countReminderMsg || item.msgAlertCount || 0}
                                          </button>
                                        </div>
                                      </td>
                                    )}
                                    {type !== "partner" && (
                                      <React.Fragment>
                                        <td className="pb-0" style={{ minWidth: "175px" }}>
                                          <div className="wf-agency-card">
                                            <div className="wf-agency-body">
                                              {getFieldData(item.performerData, "projectengagement", "AgencyName") ? (
                                                <span className="wf-info-title-text">
                                                  {getFieldData(item.performerData, "projectengagement", "AgencyName")}
                                                </span>
                                              ) : (
                                                <span className="wf-agency-empty">
                                                  <span className="wf-identity-meta-icon wf-icon-client">
                                                    <i className="fa fa-briefcase" />
                                                  </span>
                                                  No Agency
                                                </span>
                                              )}
                                              {getProjectValue(item, ["ClientName", "Client_Name", "EndClient", "End_Client", "Client"]) && (
                                                <div className="wf-info-row">
                                                  <div className="wf-identity-meta-icon wf-icon-client">
                                                    <i className="fa fa-briefcase" />
                                                  </div>
                                                  <span>Client:</span>
                                                  <span className="wf-info-value">
                                                    {getProjectValue(item, ["ClientName", "Client_Name", "EndClient", "End_Client", "Client"])}
                                                  </span>
                                                </div>
                                              )}
                                              {shouldShowAgencyRate(item) && (
                                                <div className="wf-info-row">
                                                  <div className="wf-identity-meta-icon wf-icon-money">
                                                    <i className="fa fa-money" />
                                                  </div>
                                                  <span>Rate:</span>
                                                  <span className="wf-info-value">
                                                    <RateEncryptDecrypt rateData={item?.rates?.agencyRate} />
                                                  </span>
                                                </div>
                                              )}
                                              {getAdminAgencyFee(item) && (
                                                <div className="wf-info-row">
                                                  <div className="wf-identity-meta-icon wf-icon-percent">
                                                    <i className="fa fa-percent" />
                                                  </div>
                                                  <span>{getAdminAgencyFee(item)}</span>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          <div className="wf-entity-action-bar wf-agency-action-bar">
                                            <div className="wf-entity-action-bar-row">
                                              <button
                                                type="button"
                                                className="wf-tool-btn is-docs"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  if (item.applications?.length > 0) {
                                                    handleWorkflowPanelOpen("contracts", item, item.applications[0], "agency");
                                                  }
                                                }}
                                                title="View Agency/Client Documents"
                                              >
                                                Documents
                                              </button>
                                              <button
                                                type="button"
                                                className="wf-tool-btn is-form"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleViewcandidateForm("Agency", key, item);
                                                }}
                                                title="Agency/Client Onboarding Form"
                                              >
                                                View
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td className="pb-0 wf-subcontractor-column" style={{ minWidth: "330px" }}>
                                          {getFieldData(item.performerData, "candidateonboardingform", "CandidateEntity") === "C2C Basis" && item.subcontractor ? (
                                            <div className="wf-partner-column-stack">
                                              <div className="wf-partner-summary-card">
                                                <div className="wf-partner-card">
                                                  <div className="wf-partner-left">
                                                    <div
                                                      className={`wf-partner-avatar${item.subcontractor.useFlag ? "" : " is-inactive"}`}
                                                    >
                                                      {(item.subcontractor?.label || "")
                                                        .split(" ")
                                                        .filter(Boolean)
                                                        .slice(0, 2)
                                                        .map((w) => w[0])
                                                        .join("")
                                                        .toUpperCase() || "SC"}
                                                    </div>
                                                    {item.subcontractor?.fuid && (
                                                      <span className="wf-partner-avatar-id">#{item.subcontractor.fuid}</span>
                                                    )}
                                                  </div>
                                                  <div className="wf-partner-body">
                                                    <div className="wf-partner-name-row">
                                                      <span className="wf-partner-name">{item.subcontractor?.label}</span>
                                                      <span
                                                        className={`wf-partner-status-icon ${item.subcontractor.useFlag ? "is-active" : "is-inactive"}`}
                                                        title={item.subcontractor.useFlag ? "Active subcontractor" : "Inactive subcontractor"}
                                                      >
                                                        <i className={`fa ${item.subcontractor.useFlag ? "fa-check" : "fa-times"}`} />
                                                      </span>
                                                    </div>
                                                    {item.subcontractor?.email && (
                                                      <div className="wf-partner-info-row">
                                                        <div className="wf-identity-meta-icon wf-icon-email">
                                                          <i className="fa fa-envelope-o" />
                                                        </div>
                                                        <span className="wf-identity-meta-text">{item.subcontractor.email}</span>
                                                      </div>
                                                    )}
                                                    {getFieldData(item.performerData, "subcontractorenrollmentform", "Company_Phone") && (
                                                      <div className="wf-partner-info-row">
                                                        <div className="wf-identity-meta-icon wf-icon-phone">
                                                          <i className="fa fa-phone" />
                                                        </div>
                                                        <span className="wf-partner-info-text">{getFormatedNumber(getFieldData(item.performerData, "subcontractorenrollmentform", "Company_Phone"))}</span>
                                                      </div>
                                                    )}
                                                    {shouldShowSubcontractorRate(item) && (
                                                      <div className="wf-partner-info-row">
                                                        <div className="wf-identity-meta-icon wf-icon-money">
                                                          <i className="fa fa-money" />
                                                        </div>
                                                        <span className="wf-rate-label">Rate:</span>
                                                        <span className="wf-partner-info-text">
                                                          <RateEncryptDecrypt rateData={item?.rates?.subcontractorRate} />
                                                        </span>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="wf-entity-action-bar">
                                                <div className="wf-entity-action-bar-row">
                                                  <button
                                                    type="button"
                                                    className="wf-tool-btn is-form"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleViewcandidateForm("Subcontractor", key, item);
                                                    }}
                                                    title="Onboarding Form"
                                                  >
                                                    Onboarding Form
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className="wf-tool-btn is-docs"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      if (item.applications?.length > 0) {
                                                        handleWorkflowPanelOpen("contracts", item, item.applications[0], "Subcontractor");
                                                      }
                                                    }}
                                                    title="View Documents"
                                                  >
                                                    Documents
                                                    {(item.subcontractor?.docsCount > 0 || item.subcontractor?.documentsCount > 0) && (
                                                      <span className="wf-tool-count">
                                                        {item.subcontractor?.docsCount || item.subcontractor?.documentsCount}
                                                      </span>
                                                    )}
                                                  </button>
                                                </div>
                                                <div className="wf-entity-action-bar-row">
                                                  <button
                                                    type="button"
                                                    className="wf-tool-btn is-po"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      if (item.applications?.length > 0) {
                                                        handleWorkflowPanelOpen("purchaseOrder", item, item.applications[0], "Subcontractor");
                                                      }
                                                    }}
                                                    title="Purchase Orders"
                                                  >
                                                    PO
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className="wf-tool-btn is-ach"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleOpenPartnerList("subcontractor", item);
                                                    }}
                                                    title="Open subcontractor list filtered to this subcontractor"
                                                  >
                                                    View
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            <span className="wf-entity-badge" style={{ background: "#f1f5f9", borderColor: "#cbd5e1", color: "#64748b" }}>N/A</span>
                                          )}
                                        </td>
                                        <td className="pb-0 wf-recruiter-column" style={{ minWidth: "330px" }}>
                                          {item.recruiter ? (
                                            <div className="wf-partner-column-stack">
                                              <div className="wf-partner-summary-card">
                                                <div className="wf-partner-card">
                                                  <div className="wf-partner-left">
                                                    <div
                                                      className={`wf-partner-avatar is-recruiter${item.recruiter.useFlag ? "" : " is-inactive"}`}
                                                    >
                                                      {(item.recruiter?.label || "")
                                                        .split(" ")
                                                        .filter(Boolean)
                                                        .slice(0, 2)
                                                        .map((w) => w[0])
                                                        .join("")
                                                        .toUpperCase() || "RC"}
                                                    </div>
                                                    {item.recruiter?.fuid && (
                                                      <span className="wf-partner-avatar-id">#{item.recruiter.fuid}</span>
                                                    )}
                                                  </div>
                                                  <div className="wf-partner-body">
                                                    <div className="wf-partner-name-row">
                                                      <span className="wf-partner-name">{item.recruiter?.label}</span>
                                                      <span
                                                        className={`wf-partner-status-icon ${item.recruiter.useFlag ? "is-active" : "is-inactive"}`}
                                                        title={item.recruiter.useFlag ? "Active recruiter" : "Inactive recruiter"}
                                                      >
                                                        <i className={`fa ${item.recruiter.useFlag ? "fa-check" : "fa-times"}`} />
                                                      </span>
                                                    </div>
                                                    {item.recruiter?.email && (
                                                      <div className="wf-partner-info-row">
                                                        <div className="wf-identity-meta-icon wf-icon-email">
                                                          <i className="fa fa-envelope-o" />
                                                        </div>
                                                        <span className="wf-identity-meta-text">{item.recruiter.email}</span>
                                                      </div>
                                                    )}
                                                    {getFieldData(item.performerData, "recruiterenrollmentform", "Company_Phone") && (
                                                      <div className="wf-partner-info-row">
                                                        <div className="wf-identity-meta-icon wf-icon-phone">
                                                          <i className="fa fa-phone" />
                                                        </div>
                                                        <span className="wf-partner-meta-text">{getFormatedNumber(getFieldData(item.performerData, "recruiterenrollmentform", "Company_Phone"))}</span>
                                                      </div>
                                                    )}
                                                    {shouldShowRecruiterRate(item) && (
                                                      <div className="wf-partner-info-row">
                                                        <div className="wf-identity-meta-icon wf-icon-money">
                                                          <i className="fa fa-money" />
                                                        </div>
                                                        <span className="wf-rate-label">Rate:</span>
                                                        <span className="wf-partner-info-text">
                                                          <RateEncryptDecrypt rateData={item?.rates?.recruiterRate} />
                                                        </span>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="wf-entity-action-bar">
                                                <div className="wf-entity-action-bar-row">
                                                  <button
                                                    type="button"
                                                    className="wf-tool-btn is-form"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleViewcandidateForm("Recruiter", key, item);
                                                    }}
                                                    title="Onboarding Form"
                                                  >
                                                    Onboarding Form
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className="wf-tool-btn is-docs"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      if (item.applications?.length > 0) {
                                                        handleWorkflowPanelOpen("contracts", item, item.applications[0], "Recruiter");
                                                      }
                                                    }}
                                                    title="View Documents"
                                                  >
                                                    Documents
                                                    {(item.recruiter?.docsCount > 0 || item.recruiter?.documentsCount > 0) && (
                                                      <span className="wf-tool-count">
                                                        {item.recruiter?.docsCount || item.recruiter?.documentsCount}
                                                      </span>
                                                    )}
                                                  </button>
                                                </div>
                                                <div className="wf-entity-action-bar-row">
                                                  <button
                                                    type="button"
                                                    className="wf-tool-btn is-po"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      if (item.applications?.length > 0) {
                                                        handleWorkflowPanelOpen("purchaseOrder", item, item.applications[0], "Recruiter");
                                                      }
                                                    }}
                                                    title="Purchase Orders"
                                                  >
                                                    PO
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className="wf-tool-btn is-ach"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleOpenPartnerList("recruiter", item);
                                                    }}
                                                    title="Open recruiter list filtered to this recruiter"
                                                  >
                                                    View
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            <span className="wf-entity-badge" style={{ background: "#f1f5f9", borderColor: "#cbd5e1", color: "#64748b" }}>N/A</span>
                                          )}
                                        </td>
                                        <td className="pb-0" style={{ minWidth: "150px" }}>
                                          <div className="wf-metric-card">
                                            <div className="wf-metric-avatar is-msp">
                                              <i className="fa fa-sitemap" />
                                            </div>
                                            <div className="wf-metric-body">
                                              {getFieldData(item.performerData, "candidateonboardingform", "Msp_Mode") !== "" ? (
                                                <>
                                                  <span className="wf-info-title-text">
                                                    {getFieldData(item.performerData, "candidateonboardingform", "Msp_Mode") === "Others"
                                                      ? getFieldData(item.performerData, "candidateonboardingform", "MSP_Other_Mode")
                                                      : getFieldData(item.performerData, "candidateonboardingform", "Msp_Mode")}
                                                  </span>
                                                  <div className="wf-info-row">
                                                    <div className="wf-identity-meta-icon wf-icon-percent">
                                                      <i className="fa fa-percent" />
                                                    </div>
                                                    <span>Admin Fee:</span>
                                                    <span className="wf-info-value">
                                                      <RateEncryptDecrypt
                                                        rateData={getFieldData(item.performerData, "candidateonboardingform", "Msp_AdminFee")}
                                                        startSymbol=""
                                                        endSymbol="%"
                                                      />
                                                    </span>
                                                  </div>
                                                </>
                                              ) : (
                                                <span className="wf-metric-empty">
                                                  <span className="wf-identity-meta-icon wf-icon-client">
                                                    <i className="fa fa-sitemap" />
                                                  </span>
                                                  N/A
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                          {getFieldData(item.performerData, "candidateonboardingform", "Msp_Mode") !== "" && (
                                            <div className="wf-entity-action-bar">
                                              <div className="wf-entity-action-bar-row">
                                                <button
                                                  type="button"
                                                  className="wf-tool-btn is-docs"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (item.applications?.length > 0) {
                                                      handleWorkflowPanelOpen("contracts", item, item.applications[0], "msp");
                                                    }
                                                  }}
                                                  title="View MSP Documents"
                                                >
                                                  Documents
                                                </button>
                                                <button
                                                  type="button"
                                                  className="wf-tool-btn is-form"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleViewcandidateForm("MSP", key, item);
                                                  }}
                                                  title="MSP Onboarding Form"
                                                >
                                                  View
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                        </td>
                                        <td className="pb-0" style={{ minWidth: "160px" }}>
                                          <div className="wf-metric-card">
                                            <div className="wf-metric-avatar is-fee">
                                              <i className="fa fa-calculator" />
                                            </div>
                                            <div className="wf-metric-body">
                                              <div className="wf-info-row">
                                                <div className="wf-identity-meta-icon wf-icon-candidate">
                                                  <i className="fa fa-user-circle-o" />
                                                </div>
                                                <span>Candidate:</span>
                                                <span className="wf-info-value">
                                                  {item?.rates?.candidateTechFee ? <RateEncryptDecrypt rateData={item?.rates?.candidateTechFee} /> : "$0.00/Hr"}
                                                </span>
                                              </div>
                                              <div className="wf-info-row">
                                                <div className="wf-identity-meta-icon wf-icon-building">
                                                  <i className="fa fa-building-o" />
                                                </div>
                                                <span>Subcontractor:</span>
                                                <span className="wf-info-value">
                                                  {item?.rates?.subcontractorTechFee ? <RateEncryptDecrypt rateData={item?.rates?.subcontractorTechFee} /> : "$0.00/Hr"}
                                                </span>
                                              </div>
                                              <div className="wf-info-row">
                                                <div className="wf-identity-meta-icon wf-icon-recruiter">
                                                  <i className="fa fa-users" />
                                                </div>
                                                <span>Recruiter:</span>
                                                <span className="wf-info-value">
                                                  {item?.rates?.recruiterTechFee ? <RateEncryptDecrypt rateData={item?.rates?.recruiterTechFee} /> : "$0.00/Hr"}
                                                </span>
                                              </div>
                                              <div className="wf-info-row is-divider">
                                                <div className="wf-identity-meta-icon wf-icon-percent">
                                                  <i className="fa fa-percent" />
                                                </div>
                                                <span>Hub Fee:</span>
                                                <span className="wf-info-value">
                                                  {getFieldData(item.performerData, "candidateonboardingform", "Hub_CompanyFee") ? (
                                                    <RateEncryptDecrypt rateData={getFieldData(item.performerData, "candidateonboardingform", "Hub_CompanyFee")} startSymbol="" endSymbol="%" />
                                                  ) : "%"}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                        <td className="pb-0" style={{ minWidth: "160px" }}>
                                          <div className="wf-duration-column-stack">
                                            <div className="wf-duration-summary-card">
                                              <div className="wf-metric-avatar is-duration">
                                                <i className="fa fa-hourglass-half" />
                                              </div>
                                              <div className="wf-metric-body">
                                                {item.duration !== null ? (
                                                  <>
                                                    <span className="wf-entity-badge basis-c2c" style={{ alignSelf: "flex-start", marginBottom: "2px" }}>
                                                      <i className="fa fa-hourglass-half" /> {item.duration.duration} Months
                                                    </span>
                                                    <div className="wf-info-row">
                                                      <div className="wf-identity-meta-icon wf-icon-calendar-start">
                                                        <i className="fa fa-calendar-plus-o" />
                                                      </div>
                                                      <span>Start:</span>
                                                      <span className="wf-info-value">
                                                        <Moment format="MMM Do YYYY">
                                                          {item.duration.startDate}
                                                        </Moment>
                                                      </span>
                                                    </div>
                                                    <div className="wf-info-row">
                                                      <div className="wf-identity-meta-icon wf-icon-calendar-end">
                                                        <i className="fa fa-calendar-times-o" />
                                                      </div>
                                                      <span>End:</span>
                                                      <span className="wf-info-value">
                                                        <Moment format="MMM Do YYYY">
                                                          {item.duration.endDate}
                                                        </Moment>
                                                      </span>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <span className="wf-metric-empty">
                                                    <span className="wf-identity-meta-icon wf-icon-calendar-end">
                                                      <i className="fa fa-calendar-times-o" />
                                                    </span>
                                                    No Active Duration
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                            <div className="wf-app-actions-card">
                                              <div
                                                className="wf-action-stack"
                                                style={{
                                                  display: "flex",
                                                  flexWrap: "wrap",
                                                  gap: "6px",
                                                }}
                                              >
                                                <button
                                                  type="button"
                                                  className="wf-tool-btn is-form"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDurationAndRateShowHide(item, "duration", key);
                                                  }}
                                                  title="Edit Duration"
                                                >
                                                  Duration
                                                </button>
                                                <button
                                                  type="button"
                                                  className="wf-tool-btn is-ach"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDurationAndRateShowHide(item, "rate", key);
                                                  }}
                                                  title="Modify Rate"
                                                >
                                                  Rate
                                                </button>
                                                {checkTerminateDuration(item, key)}
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </React.Fragment>
                                    )}
                                  </React.Fragment>
                                )}
                                {type !== "timelog" && type !== "invoice" && type !== "application" && (
                                  <>
                                    <td
                                      style={{ minWidth: "160px" }}
                                      onClick={(event) => event.stopPropagation()}
                                    >
                                      <div className="wf-activation-stack">
                                        <span
                                          className={`wf-status-pill ${getCandidateActivationStatus(item).className}`}
                                        >
                                          <i className={`fa ${getCandidateActivationStatus(item).icon}`} />
                                          {getCandidateActivationStatus(item).label}
                                        </span>

                                        {item.isActiveDateTime && (
                                          <div className="wf-identity-meta-row">
                                            <div className="wf-identity-meta-icon wf-icon-calendar">
                                              <i className="fa fa-calendar-o" />
                                            </div>
                                            <span className="wf-identity-meta-text">
                                              <Moment format="MMM Do YYYY">
                                                {item.isActiveDateTime}
                                              </Moment>
                                            </span>
                                          </div>
                                        )}

                                        {item.isActive !== null && item.performerid && (
                                          <button
                                            type="button"
                                            className="wf-link-action"
                                            onClick={() => handleRemainder(item.performerid)}
                                            style={{ alignSelf: "flex-start" }}
                                          >
                                            <i className="fa fa-paper-plane-o" />
                                            Resend activation
                                          </button>
                                        )}
                                      </div>
                                    </td>

                                  </>
                                )}

                              </tr>
                            </React.Fragment>
                          )))}
                      </tbody>
                    </table>

                    {!isTableLoading && candidates.length > 0 && selectedKey === -1 && SelectedFormKey === -1 && (
                      <div className="mt-3">
                        <Pagination
                          currentPage={currentPage}
                          pageSize={pageSize}
                          itemsCount={rowsCount}
                          onPageChange={handlePageChange}
                          startIndex={startIndex}
                          endIndex={endIndex}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}

              {selectedTabKey === "addEditCandidate" && type === "application" && (
                <AddCandidate
                  selectedObj={selectedObj}
                  setSelectedTabKey={setSelectedTabKey}
                  setSelectedCandidateId={setSelectedCandidateId}
                  selectedTabKey={selectedTabKey}
                  actType={selectedCandidateId === 0 ? "add" : "edit"}
                  handleAddEditCandidate={handleAddEditCandidate}
                  handleGoBack={handleGoBackCan}
                  onCandidateSaved={handleCandidateSaved}
                />
              )}

              {selectedTabKey === "onboardingForm" && type === "application" && (
                <div className="wf-tab-panel pt-2">
                  {!candidateObj || !viewFormType ? (
                    <div className="wf-empty-state">
                      <div className="wf-empty-icon">
                        <i className="fa fa-list-alt" />
                      </div>
                      <p className="wf-empty-title">
                        {viewFormTabTitle || "Onboarding Form"}
                      </p>
                      <p className="wf-empty-desc">
                        Select an onboarding form from the candidate table to view details.
                      </p>
                      <button
                        className="btn-action-search"
                        onClick={() => {
                          handleCloseViewForm();
                          setSelectedTabKey("home");
                        }}
                        style={{ marginTop: 4 }}
                      >
                        <i className="fa fa-arrow-left" /> Back
                      </button>
                    </div>
                  ) : (
                    <div className="bg-white rounded border">
                      {["Agency", "MSP"].includes(viewFormType) ? (
                        <ViewCandidate
                          handleDurationShowHide={handleDurationAndRateShowHide}
                          heading={""}
                          viewShowHide={true}
                          handleViewShowHide={handleViewShowHide}
                          selectedObj={candidateObj}
                          viewType={viewFormType.toLowerCase()}
                          filterSubcontractorList={filterSubcontractorList}
                          filterRecruiterList={filterRecruiterList}
                          title={viewFormTabTitle || getOnboardingFormTitle(viewFormType)}
                          onClose={() => {
                            handleCloseViewForm();
                            setSelectedTabKey("home");
                          }}
                          wfTask={wfTask}
                          embedded={true}
                        />
                      ) : (
                        <div className={"col-md-12 p-3"}>

                          <div className="as-form-header mb-4">
                            <div className="as-form-header-left">
                              <div className="as-form-header-icon">
                                <i className="fa fa-user-circle-o" />
                              </div>
                              <div className="as-form-header-text">
                                <p className="as-form-header-title">
                                  {viewFormTabTitle || getOnboardingFormTitle(viewFormType)}
                                </p>
                                <p className="as-form-header-sub">
                                  Complete the onboarding process by reviewing and submitting form details.
                                </p>
                                <div className="as-form-header-meta">
                                  <span className="as-meta-pill meta-id">
                                    <i className="fa fa-id-badge" /> ID: {candidateObj?.performerid || "N/A"}
                                  </span>
                                  {candidateObj?.performername && (
                                    <span className="as-meta-pill meta-person">
                                      <i className="fa fa-user" /> {candidateObj.performername}
                                    </span>
                                  )}
                                  {candidateObj?.performeremail && (
                                    <span className="as-meta-pill meta-email">
                                      <i className="fa fa-envelope-o" /> {candidateObj.performeremail}
                                    </span>
                                  )}
                                  {wfTask?.ciid > 0 && (
                                    <span className="as-meta-pill meta-ciid">
                                      <i className="fa fa-hashtag" /> CIID {wfTask.ciid}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="as-form-header-right">
                              <button
                                className="as-header-back-btn"
                                onClick={() => {
                                  handleCloseViewForm();
                                  setSelectedTabKey("home");
                                }}
                              >
                                <i className="fa fa-arrow-left mr-2"></i>Back
                              </button>
                            </div>
                          </div>

                          {wfForm ? (
                            <WorkflowElement
                              wfTask={wfTask}
                              wfForm={wfForm}
                              handleNextTask={handleNextTask}
                              viewType={true}
                              appSummary={false}
                              codeVerified={true}
                              wfTaskType={"form"}
                              updatedStateData={updatedStateData}
                            />
                          ) : (
                            <div className="wf-loading-container" style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "60px 20px",
                              background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                              borderRadius: "12px",
                              border: "1px solid #e2e8f0",
                              boxShadow: "0 10px 15px -3px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.05)",
                              margin: "20px auto",
                              maxWidth: "480px"
                            }}>
                              <div className="wf-loader-spinner" style={{
                                position: "relative",
                                width: "64px",
                                height: "64px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}>
                                <div className="spinner-double-ring" style={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  border: "4px solid transparent",
                                  borderTopColor: "#0f766e",
                                  borderBottomColor: "#0f766e",
                                  borderRadius: "50%",
                                  animation: "spin 1.5s linear infinite"
                                }} />
                                <div className="spinner-inner-ring" style={{
                                  position: "absolute",
                                  width: "70%",
                                  height: "70%",
                                  border: "3px solid transparent",
                                  borderLeftColor: "#2563eb",
                                  borderRightColor: "#2563eb",
                                  borderRadius: "50%",
                                  animation: "spin-reverse 1.2s linear infinite"
                                }} />
                                <i className="fa fa-pencil-square-o" style={{ fontSize: "20px", color: "#0f766e" }} />
                              </div>

                              <p style={{
                                margin: "20px 0 6px 0",
                                color: "#1e293b",
                                fontSize: "14px",
                                fontWeight: 500,
                                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                                letterSpacing: "-0.01em"
                              }}>
                                Fetching Onboarding Schema
                              </p>
                              <p style={{
                                margin: 0,
                                color: "#64748b",
                                fontSize: "14px",
                                fontWeight: 400,
                                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                                textAlign: "center"
                              }}>
                                Please wait while we retrieve the {viewFormType} onboarding form details.
                              </p>

                              <div style={{
                                width: "120px",
                                height: "3px",
                                background: "#e2e8f0",
                                borderRadius: "2px",
                                marginTop: "16px",
                                overflow: "hidden",
                                position: "relative"
                              }}>
                                <div style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "40%",
                                  background: "linear-gradient(90deg, #0f766e, #2563eb)",
                                  borderRadius: "2px",
                                  animation: "pulse-loader 1.5s infinite ease-in-out"
                                }} />
                              </div>

                              <style dangerouslySetInnerHTML={{
                                __html: `
                                @keyframes spin {
                                  0% { transform: rotate(0deg); }
                                  100% { transform: rotate(360deg); }
                                }
                                @keyframes spin-reverse {
                                  0% { transform: rotate(360deg); }
                                  100% { transform: rotate(0deg); }
                                }
                                @keyframes pulse-loader {
                                  0% { left: -40%; }
                                  50% { left: 100%; }
                                  100% { left: -40%; }
                                }
                              `}} />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {["contracts", "ach", "purchaseOrder"].includes(selectedTabKey) &&
                type === "application" && (
                  <div className="wf-tab-panel pt-2">
                    {!selectedApp || !selectedCurrentTask ? (
                      <div className="wf-empty-state">
                        <div className="wf-empty-icon">
                          <i
                            className={`fa ${selectedTabKey === "contracts"
                              ? "fa-file-text-o"
                              : selectedTabKey === "ach"
                                ? "fa-bank"
                                : "fa-shopping-cart"
                              }`}
                          />
                        </div>
                        <p className="wf-empty-title">No Candidate Application Selected</p>
                        <p className="wf-empty-desc">
                          Select a candidate application from the table to view
                          {selectedTabKey === "contracts" && "contract documents"}
                          {selectedTabKey === "ach" && "ACH information"}
                          {selectedTabKey === "purchaseOrder" && "purchase orders"}.
                        </p>
                        <button
                          className="btn-action-search"
                          onClick={() => setSelectedTabKey("home")}
                          style={{ marginTop: 4 }}
                        >
                          <i className="fa fa-arrow-left" /> Back to Candidates
                        </button>
                      </div>
                    ) : (
                      <div style={{ border: "none", background: "transparent", padding: 0 }}>
                        {selectedTabKey === "contracts" && (
                          <Document
                            documents={appDocumentSelector}
                            workflowTask={selectedCurrentTask}
                            uploadType={docUploadType}
                            app={selectedApp}
                            item={selectedObj}
                            viewType={"candidateList"}
                            onBack={() => setSelectedTabKey("home")}
                          />
                        )}

                        {selectedTabKey === "ach" && (
                          <AchInformation
                            workflowTask={selectedCurrentTask}
                            app={selectedApp}
                            item={selectedObj}
                            setViewBprmFormShowHide={setViewBprmFormShowHide}
                            viewType={"candidateList"}
                            achType={"Candidate"}
                            setSelectedApp={setSelectedApp}
                            onBack={() => setSelectedTabKey("home")}
                          />
                        )}

                        {selectedTabKey === "purchaseOrder" && (
                          <PurchaseOrderPopup
                            purchaseShowHide={true}
                            handlePurchaseShowHide={handlePurchaseShowHide}
                            candidateObj={selectedObj}
                            workflowTask={selectedCurrentTask}
                            poOrderType={"add"}
                            item={{ partnerType: docUploadType === "Subcontractor" || docUploadType === "Recruiter" ? docUploadType : (selectedObj?.subcontractor?.fuid > 0 ? "Subcontractor" : "Recruiter") }}
                            handleSignUnsignPo={handleSignUnsignPo}
                            handleRefreshPoOrders={handleRefreshPoOrders}
                            renderType="generate"
                            onBack={() => setSelectedTabKey("home")}
                          />
                        )}
                      </div>
                    )}
                  </div>
                )}

              {selectedTabKey === "duration" && type === "application" && (
                <div className="wf-tab-panel pt-2">
                  {!selectedObj ? (
                    <div className="wf-empty-state">
                      <div className="wf-empty-icon">
                        <i className="fa fa-calendar" />
                      </div>
                      <p className="wf-empty-title">No Candidate Selected</p>
                      <p className="wf-empty-desc">
                        Select a candidate from the table to view and edit duration details.
                      </p>
                      <button
                        className="btn-action-search"
                        onClick={() => setSelectedTabKey("home")}
                        style={{ marginTop: 4 }}
                      >
                        <i className="fa fa-arrow-left" /> Back to Candidates
                      </button>
                    </div>
                  ) : (
                    <AddEditDuration
                      handleDurationShowHide={(obj, actType, k) => {
                        if (actType === "save" || k === -1) {
                          setSelectedTabKey("home");
                          setEditDurType("");
                        } else {
                          handleDurationAndRateShowHide(obj, actType, k);
                        }
                      }}
                      selectedObj={selectedObj}
                      editType={editDurType || "duration"}
                    />
                  )}
                </div>
              )}

              {selectedTabKey === "rate" && type === "application" && (
                <div className="wf-tab-panel pt-2">
                  {!selectedObj ? (
                    <div className="wf-empty-state">
                      <div className="wf-empty-icon">
                        <i className="fa fa-money" />
                      </div>
                      <p className="wf-empty-title">No Candidate Selected</p>
                      <p className="wf-empty-desc">
                        Select a candidate from the table to view and edit rate details.
                      </p>
                      <button
                        className="btn-action-search"
                        onClick={() => setSelectedTabKey("home")}
                        style={{ marginTop: 4 }}
                      >
                        <i className="fa fa-arrow-left" /> Back to Candidates
                      </button>
                    </div>
                  ) : (
                    <AddEditRates
                      handleDurationShowHide={(obj, actType, k) => {
                        if (actType === "save" || k === -1) {
                          setSelectedTabKey("home");
                          setEditDurType("");
                        } else {
                          handleDurationAndRateShowHide(obj, actType, k);
                        }
                      }}
                      selectedObj={selectedObj}
                      editType={editDurType || "rate"}
                    />
                  )}
                </div>
              )}

              {selectedTabKey === "status" && type === "partner" && (
                <div className="mt-3 bg-white p-3 rounded border wf-tab-panel">
                  {selectedCandidateId === 0 ? (
                    <div className="wf-empty-state">
                      <div className="wf-empty-icon">
                        <i className="fa fa-toggle-on" />
                      </div>
                      <p className="wf-empty-title">No Candidate Selected</p>
                      <p className="wf-empty-desc">
                        Select a candidate from the table to view its activation history.
                      </p>
                      <button
                        className="btn-action-search"
                        onClick={() => setSelectedTabKey("home")}
                        style={{ marginTop: 4 }}
                      >
                        <i className="fa fa-arrow-left" /> Back to Candidates
                      </button>
                    </div>
                  ) : (
                    <ActiveDeactiveHistory
                      selectedObj={selectedObj}
                      type="performer"
                      typeName="Candidate"
                      actionType={actionType}
                      handlePermissionShowHide2={handlePermissionShowHide2}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ReminderAlertMessage
        remainderMsgShowHide={remainderMsgShowHide}
        handleRemainderMessage={handleRemainderMessage}
      />
    </React.Fragment >
  );
}
